import { React, useEffect, useState, useRef } from 'react';
import { Link as RouterLink, useNavigate, useLocation, useOutletContext } from 'react-router-dom';
import { DataGrid, GridToolbar, GridPagination } from '@mui/x-data-grid';
import { alpha, styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowRightOutlined';

// material
import {
    Card,
    IconButton,
    Stack,
    Button,
    TextField,
    Divider,
    FormControl,
    MenuItem,
    InputLabel, Select,
    Autocomplete,
    Tooltip,
    FormGroup,
    FormControlLabel,
    Checkbox,
    ListItemText,
    Grid,
    Typography, CardContent,
    Link,
    Box,
    Tabs,
    Tab,
    Badge,
    FormLabel,
    Modal,
    Chip,
    TextareaAutosize,
    Menu,
    ListItemIcon,
    MobileStepper
} from '@mui/material';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip as RechartsTooltip,
    ResponsiveContainer,
    LabelList,
    PieChart,
    Pie,
    Cell,
    Legend
} from "recharts";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { format, parse, isValid, startOfDay, startOfMonth, endOfMonth, eachDayOfInterval, isSameDay, getDay } from "date-fns";
import { useSnackbar } from 'notistack';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import Moment from 'moment';
import { Icon } from '@iconify/react';
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SubdirectoryArrowRightOutlinedIcon from "@mui/icons-material/SubdirectoryArrowRightOutlined";
import AddIcon from '@mui/icons-material/Add';
import AppCache from '../../../services/AppCache';
import URLS from '../../../services/urls.service';
import LoadingProgressBar from '../../../theme/overrides/LoadingProgressBar';
import Page from '../../../components/Page';
import { handleError } from '../../../components/Common/Utils';
import Blog from '../../../pages/Blog'
import Iconify from '../../../components/Iconify';
import ApplyForLeave from '../../../components/SidebarMenuComponents/LeaveComponent/ApplyForLeave';
import LeaveHistory from '../../../components/SidebarMenuComponents/LeaveComponent/LeaveHistory';
import LeaveRequest from '../../../components/SidebarMenuComponents/LeaveComponent/LeaveRequest';
import MyTeam from '../../../components/SidebarMenuComponents/LeaveComponent/MyTeam';
import AttendanceReport from '../../../components/SidebarMenuComponents/LeaveComponent/AttendanceReport';
import LeaveBalanceReport from '../../../components/SidebarMenuComponents/LeaveComponent/LeaveBalanceReport';

// ----------------------------------------------------------------------


const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

// ----------------------------------------------------------------------
const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '70%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    height: '92%',
    overflow: 'auto',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
};
// --- Custom Styled Components ---

const StyledTabs = styled(Tabs)({
    minHeight: '35px',
    '& .MuiTabs-indicator': {
        display: 'none', // Hide default indicator
    },
});

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '14px',
    marginRight: theme.spacing(0.5),
    // padding: '8px 20px',
    minHeight: '35px',
    color: '#7B7B7B',
    borderRadius: '8px 8px 0px 0px',
    border: '1px solid transparent', // Maintain layout stability
    '&.Mui-selected': {
        color: '#000',
        fontWeight: 600,
        backgroundColor: '#fff',
        borderTop: '1px solid #e8e8e8',
        borderLeft: '1px solid #e8e8e8',
        borderRight: '1px solid #e8e8e8',
        borderBottom: '1px solid #fff', // This "cuts" the main box border
        marginBottom: '-1px', // Overlaps the border below
        zIndex: 1,
    },
}));

const rightCardStyle = {
    flex: 1,
    minHeight: 0,
    p: 1,
    borderRadius: "12px",
    border: "1px solid #E5E7EB",
    boxShadow: "none",
    overflow: "hidden",   // ✅ important
    backgroundColor: '#FFFFFF',
    height: "100%"
};

const cardStyle = {
    flex: 1,
    minHeight: 0,
    p: 1.5,
    borderRadius: "12px",
    border: "1px solid #E5E7EB",
    boxShadow: "none",
    overflowY: "auto",
};
const tmpCache = {};

const stripHtml = (html) => {
    const temp = document.createElement('div');
    temp.innerHTML = html;
    return temp.textContent || temp.innerText || '';
};
export default function LeaveDetailsPage() {
    const location = useLocation();
    const { enqueueSnackbar } = useSnackbar();

    const { onOpenSidebar, open, onCloseSidebar, previousPath, currentPath, acknowledgeData } = useOutletContext();

    const handleFilterClick = () => {
        onOpenSidebar(); // expand sidebar if collapsed
    };
    const handleFilterCollapseClick = () => {
        onCloseSidebar(); // expand sidebar if collapsed
    };

    const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();
    const userId = CurrentLoggedInUser.ExecutiveId;
    const userClientId = CurrentLoggedInUser?.UserClientId;
    const reportingToId = CurrentLoggedInUser?.ReportingToId;

    console.log("open>>>>>>>>>>>>>>>>>>", open, reportingToId)
    const isLongLeaveApprover = CurrentLoggedInUser?.IsLongLeaveApprover;

    const [isLoading, setIsLoading] = useState(false);
    const [value, setValue] = useState(0);

    const [closingBalance, setClosingBalance] = useState([]);
    // Apply for leave
    const pastLeaveColumns = [
        {
            field: 'LeaveDate',
            headerName: 'Date',
            flex: 0.8,
        },
        {
            field: 'LeaveTypeName',
            headerName: 'Leave Details',
            flex: 0.8,
        },
        {
            field: 'IsApproved',
            headerName: 'Status',
            flex: 0.5,
            renderCell: ({ value }) => {
                const isApproved =
                    String(value).toLowerCase() === "true";

                if (!isApproved) return null;

                return (
                    <Chip
                        label="Approved"
                        size="small"
                        sx={{
                            backgroundColor: '#E5F5EB',
                            color: '#00A63E',
                            fontSize: '12px',
                            borderRadius: '6px',
                            fontWeight: 500

                        }}
                    />
                );
            }
        }
    ];

    const upcomingLeaveColumns = [
        {
            field: 'LeaveDate',
            headerName: 'Date',
            flex: 0.8,
        },
        {
            field: 'LeaveTypeName',
            headerName: 'Leave Details',
            flex: 0.8,
        },
        {
            field: 'IsApproved',
            headerName: 'Status',
            flex: 0.5,
            renderCell: ({ value }) => {
                const isApproved =
                    String(value).toLowerCase() === "true";

                return (
                    <Chip
                        label={isApproved ? "Approved" : "Pending"}
                        size="small"
                        sx={{
                            backgroundColor: isApproved ? '#E5F5EB' : '#FEF9C2',
                            color: isApproved ? '#00A63E' : '#894B00',
                            fontSize: '12px',
                            borderRadius: '6px',
                            fontWeight: 500
                        }}
                    />
                );
            }
        }
    ];

    const teamImpactColumns = [
        {
            field: 'ExecutiveName',
            headerName: 'Executive Name',
            flex: 0.5,
        },
        {
            field: 'IsApproved',
            headerName: 'Status',
            flex: 0.5,
            renderCell: ({ value }) => {
                const isApproved =
                    String(value).toLowerCase() === "true";

                return (
                    <Chip
                        label={isApproved ? "Approved" : "Pending"}
                        size="small"
                        sx={{
                            backgroundColor: isApproved ? '#E5F5EB' : '#FEF9C2',
                            color: isApproved ? '#00A63E' : '#894B00',
                            fontSize: '12px',
                            borderRadius: '6px',
                            fontWeight: 500
                        }}
                    />
                );
            }
        }
    ];
    // leave history
    const statusStyles = {
        Approved: { color: '#00A63E', bgColor: '#E5F5EB' },
        Pending: { color: '#894B00', bgColor: '#FEF9C2' },
        Rejected: { color: '#D93A46', bgColor: '#FAE3E6' }
    };
    const historyColumns = [
        { field: 'LeaveType', headerName: 'Leave Type', flex: 1 },
        {
            field: 'EntryDate',
            headerName: 'Applied Date',
            flex: 1,
            renderCell: (params) =>
                params?.row?.EntryDate
                    ? Moment(params.row.EntryDate).format("DD-MMM-YYYY")
                    : ""
        },
        { field: 'LeaveRemarks', headerName: 'Remark', flex: 1.5 },
        {
            field: 'LeaveDate',
            headerName: 'Dates',
            flex: 1.5,
            renderCell: (params) => params.row.LeaveDate || ""
        },
        { field: 'TotalDays', headerName: 'Total Days', flex: 0.8, align: 'center' },
        {
            field: 'Status',
            headerName: 'Status',
            flex: 1,
            renderCell: (params) => {
                const status = params.value;

                const style = statusStyles[status] || {
                    color: '#333',
                    bgColor: '#eee'
                };

                return (
                    <Chip
                        label={status}
                        size="small"
                        sx={{
                            color: style.color,
                            bgcolor: style.bgColor,
                            fontWeight: 500,
                            fontSize: 12
                        }}
                    />
                );
            }
        },
        {
            field: 'actions',
            headerName: 'Action',
            type: 'actions',
            flex: 0.5,
            headerAlign: 'right',
            align: 'right',
            renderCell: (cellValues) => (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        width: "100%",
                        pr: 0.5,
                        boxShadow: 'none',

                    }}
                >

                    <IconButton size="small" onClick={(event) => handleMenuOpen(event, cellValues.row)}>
                        <MoreVertIcon sx={{ fontSize: 18, color: "#444" }} />
                    </IconButton>
                    <Menu
                        anchorEl={anchorEl}
                        open={openMenu}
                        onClose={handleMenuClose}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                        PaperProps={{
                            sx: {
                                boxShadow: 'none',
                                border: '1px solid #D1D5DB'
                            }
                        }}
                        MenuListProps={{
                            sx: {
                                width: 113,
                                py: 0,

                                '& .MuiMenuItem-root': {
                                    px: 1.5,

                                },
                                '& .MuiMenuItem-root .MuiListItemIcon-root': {
                                    minWidth: '0 !important',
                                },
                                '& .MuiMenuItem-root:hover': {
                                    backgroundColor: "#FFF2F0",
                                },
                            },
                        }}
                    >
                        {/* Always show View */}
                        <MenuItem onClick={() => handleViewLeaveHistoryOpenModal(selectedRow)}>
                            <ListItemIcon sx={{ minWidth: 0, mr: 1 }}>
                                <Icon icon="mdi:eye-outline" width={14} height={14} style={{ color: "#3866E3" }} />
                            </ListItemIcon>
                            <ListItemText primary="View" />
                        </MenuItem>

                        {/* Show only if Pending */}
                        {selectedRow?.Status === "Pending" && (
                            <>
                                <MenuItem onClick={() => handleEditLeave(selectedRow)}>
                                    <ListItemIcon sx={{ minWidth: 0, mr: 1 }}>
                                        <Icon icon="material-symbols:border-color-outline" width={14} height={14} style={{ color: "#0086FF" }} />

                                    </ListItemIcon>
                                    <ListItemText primary="Edit" />
                                </MenuItem>

                                <MenuItem onClick={() => handleOpenCancelModal(selectedRow)}>
                                    <ListItemIcon sx={{ minWidth: 0, mr: 1 }}>
                                        <Icon icon="material-symbols:cancel-outline" width={14} height={14} style={{ color: "#E10F00" }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Cancel" />
                                </MenuItem>
                            </>
                        )}
                    </Menu>

                </Box>
            )
        }

    ];

    const historyRows = [
        {
            id: 1,
            leaveType: 'Leave',
            appliedDate: '01-Sep-2025',
            remark: 'Not feeling well. Had cough and cold',
            dates: '02-Sep-2025',
            totalDays: '01',
            status: 'Pending'
        },
        {
            id: 2,
            leaveType: 'Leave',
            appliedDate: '20-Aug-2025',
            remark: 'Ganapati leaves',
            dates: '23-Aug-2025 ; 24-Aug-2025 ; 25-Aug-2025',
            totalDays: '03',
            status: 'Approved'
        },
        {
            id: 3,
            leaveType: 'Post-HD',
            appliedDate: '11-Aug-2025',
            remark: 'Ganapati leaves',
            dates: '26-Aug-2025',
            totalDays: '01',
            status: 'Rejected'
        }
    ];

    const myTeamColumn = [
        { field: 'Name', headerName: 'Executive Name', flex: 1.5 },
        { field: 'TeamName', headerName: 'Department', flex: 1.2 },
        { field: 'LeaveType', headerName: 'Leave Type', flex: 1 },
        { field: 'LeaveRemarks', headerName: 'Remark', flex: 1.5 },
        { field: 'EntryDate', headerName: 'Applied Date', flex: 1.2 },
        { field: 'LeaveDate', headerName: 'Dates', flex: 1.2 },
        { field: 'TotalDay', headerName: 'Total Days', flex: 0.8 },
        {
            field: 'Status',
            headerName: 'Status',
            flex: 1,
            renderCell: (params) => {
                const status = params.value;
                let color
                let bgColor

                if (status === 'Approved') { color = '#00A63E'; bgColor = '#E5F5EB'; }
                if (status === 'Pending') { color = '#894B00'; bgColor = '#FEF9C2'; }
                if (status === 'Rejected') { color = '#D93A46'; bgColor = '#FAE3E6'; }

                return (
                    <Chip
                        label={status}
                        size="small"
                        sx={{ color: color, bgcolor: bgColor, fontWeight: 500, fontSize: 12 }}
                    />
                );
            }
        },
    ];

    // leave balance report
    const leaveBalanceReportColumn = [
        { field: 'SrNo', headerName: 'Sr No.', flex: 0.5 },
        { field: 'SAPLID', headerName: 'SAPL ID', flex: 1 },
        { field: 'ExecutiveName', headerName: 'Executive Name', flex: 1 },
        { field: 'MonthYearNew', headerName: 'Month Year', flex: 1 },
        { field: 'Opening', headerName: 'Opening Balance', flex: 1 },
        { field: 'Credit', headerName: 'Credit Balance', flex: 1 },
        { field: 'Debit', headerName: 'Debit Balance', flex: 1 },
        { field: 'Closing', headerName: 'Closing Balance', flex: 1 },
        { field: 'Remark', headerName: 'Remark', flex: 1.5 },

    ];

    // leave request
    const leaveRequestColumn = [
        { field: 'Name', headerName: 'Executive Name', flex: 1.5 },
        { field: 'TeamName', headerName: 'Team', flex: 1 },
        { field: 'LeaveType', headerName: 'Leave Type', flex: 1 },
        { field: 'LeaveRemarks', headerName: 'Remark', flex: 1.5 },
        {
            field: 'EntryDate', headerName: 'Applied Date', flex: 1,
            renderCell: (params) =>
                params?.row?.EntryDate
                    ? Moment(params.row.EntryDate).format("DD-MMM-YYYY")
                    : ""
        },
        //{
        //    field: 'LeaveDate',
        //    headerName: 'Leave Dates',
        //    flex: 1.5,

        //},
        {
            field: "LeaveDate",
            headerName: "Leave Dates",
            flex: 1.5,
            renderCell: (params) => {
                const dates = params.row.LeaveDate?.split(",") || [];
                const approvals = params.row.IsApproved?.split(",") || [];

                return (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {dates.map((date, index) => (
                            <Typography
                                key={index}
                                component="span"
                                sx={{
                                    color:
                                        approvals[index] === "1"
                                            ? "#00A63E"
                                            : approvals[index] === "2"
                                                ? "#D93A46"
                                                : "inherit",
                                    fontWeight: approvals[index] === "1" ? 600 : 400,
                                }}
                            >
                                {date}
                                {index < dates.length - 1 ? ", " : ""}
                            </Typography>
                        ))}
                    </Box>
                );
            },
        },
        { field: 'TotalDay', headerName: 'Total Days', flex: 0.8, align: 'center' },
        {
            field: 'Status',
            headerName: 'Status',
            flex: 1,
            renderCell: (params) => {
                const status = params.value;
                let color
                let bgColor

                if (status === 'Approved') { color = '#00A63E'; bgColor = '#E5F5EB'; }
                if (status === 'Pending') { color = '#894B00'; bgColor = '#FEF9C2'; }
                if (status === 'Rejected') { color = '#D93A46'; bgColor = '#FAE3E6'; }
                if (status === 'Processing') { color = '#1D4ED8'; bgColor = '#DBEAFE'; }

                return (
                    <Chip
                        label={status}
                        size="small"
                        sx={{ color: color, bgcolor: bgColor, fontWeight: 500, fontSize: 12 }}
                    />
                );
            }
        },
        //{
        //    field: 'view',
        //    headerName: '',
        //    type: 'actions',
        //    width: 2,
        //    renderCell: (cellValues) => (
        //        <div>
        //            <IconButton onClick={() => handleViewClick(cellValues)}>
        //                <Iconify icon="material-symbols:visibility-outline" width='16px' height='16px' color='#3866E3' />
        //            </IconButton>

        //        </div>
        //    )
        //},
        {
            field: 'actions',
            headerName: 'Action',
            type: 'actions',
            flex: 0.5,
            headerAlign: 'right',
            align: 'right',
            renderCell: (cellValues) => (

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        width: "100%",
                        pr: 0.5,
                        boxShadow: 'none',

                    }}
                >

                    <IconButton size="small" onClick={(event) => handleLeaveRequestMenuOpen(event, cellValues.row)}>
                        <MoreVertIcon sx={{ fontSize: 18, color: "#444" }} />
                    </IconButton>
                    <Menu
                        anchorEl={leaveRequestAnchorEl}
                        open={openLeaveRequestMenu}
                        onClose={handleLeaveRequestMenuClose}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                        PaperProps={{
                            sx: {
                                boxShadow: 'none',
                                border: '1px solid #D1D5DB'
                            }
                        }}
                        MenuListProps={{
                            sx: {
                                width: 113,
                                py: 0,

                                '& .MuiMenuItem-root': {
                                    px: 1.5,

                                },
                                '& .MuiMenuItem-root .MuiListItemIcon-root': {
                                    minWidth: '0 !important',
                                },
                                '& .MuiMenuItem-root:hover': {
                                    backgroundColor: "#FFF2F0",
                                },
                            },
                        }}
                    >
                        {/* Always show View */}
                        <MenuItem onClick={() => handleViewClick(selectedRequestRow)}>
                            <ListItemIcon sx={{ minWidth: 0, mr: 1 }}>
                                <Icon icon="mdi:eye-outline" width={14} height={14} style={{ color: "#3866E3" }} />
                            </ListItemIcon>
                            <ListItemText primary="View" />
                        </MenuItem>
                        {cellValues.row.ExecutiveID !== userId && (
                            <>
                                <MenuItem onClick={() => handleLeaveRequestApprove(selectedRequestRow)}>
                                    <ListItemIcon sx={{ minWidth: 0, mr: 1 }}>
                                        <Icon icon="material-symbols:thumb-up-outline" width={14} height={14} style={{ color: "#00A63E" }} />

                                    </ListItemIcon>
                                    <ListItemText primary="Approve" />
                                </MenuItem>

                                <MenuItem onClick={() => handleLeaveRequestReject(selectedRequestRow)}>
                                    <ListItemIcon sx={{ minWidth: 0, mr: 1 }}>
                                        <Icon icon="material-symbols:thumb-down-outline" width={14} height={14} style={{ color: "#E10F00" }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Reject" />
                                </MenuItem>
                            </>
                        )}
                    </Menu>

                </Box>
            )
        }

    ];

    // Apply for leave

    const leaveOptions = [
        { Id: 0, Name: "Leave" },
        { Id: 1, Name: "Long Leave" }
    ];
    const leaveTypeOptions = [
        { "Id": 1, "Name": "Leave" }, //full day 
        { "Id": 2, "Name": "HD(Pre)" }, //Pre Lunch
        { "Id": 3, "Name": "HD(Post)" }, //PostLunch
        { "Id": 4, "Name": "Saturday Off" }, //Sat Off
        { "Id": 6, "Name": "Travel" },
        { "Id": 10, "Name": "Work from home" }
    ];

    const leavePaidOptions = [
        { Id: 0, Name: "UnPaid" },
        { Id: 1, Name: "Paid" }
    ];
    const selectedRequestStatus = [
        { Id: "Pending", Name: "Pending" },
        { Id: "Processing", Name: "Processed" },
        //{ Id: "Approved", Name: "Approved" },
        //{ Id: "Rejected", Name: "Rejected" }
    ];
    const [isManager, setIsManager] = useState(false);

    // Apply for leave
    const [date, setDate] = useState([]);
    const [rangeStartDate, setRangeStartDate] = useState(null);

    const [isShiftPressed, setIsShiftPressed] = useState(false);
    const [isCtrlPressed, setIsCtrlPressed] = useState(false);
    const [lastSelectedDate, setLastSelectedDate] = useState(null);
    const [anchorDate, setAnchorDate] = useState(null);

    const [selectedDate, setSelectedDate] = useState(null);
    const [remark, setRemark] = useState("");
    const [pageSize, setPageSize] = useState(25);
    const [pageSize1, setPageSize1] = useState(25);
    const [leaveTypeRadio, setLeaveTypeRadio] = useState({});
    const [leaveTypeDdl, setLeaveTypeDdl] = useState(leaveOptions[0]);
    const [leavePaid, setLeavePaid] = useState(leavePaidOptions[0]);
    const [fromDateLeave, setFromDateLeave] = useState(null);
    const [toDateLeave, setToDateLeave] = useState(null);
    const [pastLeaveData, setPastLeaveData] = useState([]);
    const [upcomingLeaveData, setUpcomingLeaveData] = useState([]);
    const [teamImpactLeaveData, setTeamImpactLeaveData] = useState([]);
    const [projectImpactLeaveData, setProjectImpactLeaveData] = useState([]);
    const [leaveBalanceData, setLeaveBalanceData] = useState({});
    const [openSuccess, setOpenSuccess] = useState(false);
    const [leaveHistory, setLeaveHistory] = useState([]);


    const [executiveDdl, setExecutiveDdl] = useState("");
    const [selectedExecutiveDdl, setSelectedExecutiveDdl] = useState([]);

    //Leave history
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [leaveType, setLeaveType] = useState(null);
    const [leaveHistoryData, setLeaveHistoryData] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const openMenu = Boolean(anchorEl);
    const [viewLeaveHistoryModal, setViewLeaveHistoryModal] = useState(false);
    const [viewLeaveHistoryData, setViewLeaveHistoryData] = useState([]);
    const [cancelModal, setCancelModal] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [editModalData, setEditModalData] = useState(null);
    const [cancelModalData, setCancelModalData] = useState([]);
    const [pageSize2, setPageSize2] = useState(25);

    const [executiveHistory, setExecutiveHistory] = useState();
    const [selectedExecutiveHistory, setSelectedExecutiveHistory] = useState([]);
    console.log("selectedRow", selectedRow)
    const [activeStep, setActiveStep] = useState(0);
    const maxSteps = 2;

    // My Team
    const [myTeamFromDate, setMyTeamFromDate] = useState(null);
    const [myTeamToDate, setMyTeamToDate] = useState(null);
    const [executive, setExecutive] = useState(userId);
    const [selectedExecutive, setSelectedExecutive] = useState([]);
    const [department, setDepartment] = useState("");
    const [selectedDepartment, setSelectedDepartment] = useState([]);
    const [myTeamleaveType, setMyTeamLeaveType] = useState("");
    const [myTeamSelectedLeaveType, setMyTeamSelectedLeaveType] = useState([]);
    const [team, setTeam] = useState("");
    const [selectedTeam, setSelectedTeam] = useState([]);

    const [myTeamData, setMyTeamData] = useState([]);
    const [pageSize3, setPageSize3] = useState(25);

    // AttendanceReport
    const [monthYear, setMonthYear] = useState(new Date());
    const [attendanceReportData, setAttendanceReportData] = useState([]);
    const [pageSize4, setPageSize4] = useState(25);

    // leave balance report
    const [leaveReportExecutive, setLeaveReportExecutive] = useState(userId);
    const [selectedLeaveReportExecutive, setSelectedLeaveReportExecutive] = useState("");
    const [noOfMonths, setNoOfMonths] = useState("");
    const [leaveBalanceReportData, setLeaveBalanceReportData] = useState([]);
    //Leave request
    const [requestExecutive, setRequestExecutive] = useState("");
    const [selectedRequestExecutive, setSelectedtRequestExecutive] = useState([]);
    const [requestProject, setRequestProject] = useState("");
    const [selectedRequestProject, setSelectedtRequestProject] = useState([]);
    const [requestStatus, setRequestStatus] = useState(selectedRequestStatus[0]?.Id);
    const [selectedRequestStatusnew, setSelectedtRequestStatus] = useState([]);
    const [requestDepartment, setRequestDepartment] = useState("");
    const [selectedRequestDepartment, setSelectedRequestDepartment] = useState([]);
    const [leaveRequestData, setLeaveRequestData] = useState([]);

    const [isView, setIsView] = useState(false);
    const [selectedRequestRow, setSelectedRequestRow] = useState(null);
    const [pendingApprovalData, setPendingApprovalData] = useState([]);
    const [teamPendingApprovalData, setTeamPendingApprovalData] = useState([]);
    const [managerDashboard, setManagerDashboard] = useState([]);
    const [pageSize5, setPageSize5] = useState(25);
    const [processedCards, setProcessedCards] = useState({});

    const [birthdayData, setBirthdayData] = useState([]);
    const [milestonesData, setMilestonesData] = useState([]);
    const [holidayData, setHolidayData] = useState([]);
    const [leaveHistoryPieData, setLeaveHistoryPieData] = useState([]);
    const [teamFromDate, setTeamFromDate] = useState('' || new Date());
    const [projectTeamFromDate, setProjectTeamFromDate] = useState('' || new Date());

    const [leaveRequestAnchorEl, setLeaveRequestAnchorEl] = useState(null);
    const [selectedLeaveRequestRow, setSelectedLeaveRequestRow] = useState(null);
    const openLeaveRequestMenu = Boolean(leaveRequestAnchorEl);

    const [approveModal, setApproveModal] = useState(false);
    const [rejectModal, setRejectModal] = useState(false);
    const [departmentDropdownVisible, setDepartmentDropdownVisible] = useState(false);

    const [holidayList, setHolidayList] = useState([]);


    const attendanceReportColumn = [
        {
            field: "name",
            headerName: "Executive Name",
            flex: 1.5,
            minWidth: 220,
        },

        // Day Columns 1-31
        ...Array.from({ length: 31 }, (_, i) => ({
            field: `day${i + 1}`,
            headerName: `${i + 1}`,
            flex: 0.4,
            minWidth: 40,
            sortable: false,
            align: "center",
            headerAlign: "center",
        })),

        {
            field: "present",
            headerName: "Present",
            flex: 0.6,
            minWidth: 80,
            align: "center",
            headerAlign: "center",
        },
        {
            field: "leave",
            headerName: "Leave",
            flex: 0.6,
            minWidth: 80,
            align: "center",
            headerAlign: "center",
        },
        {
            field: "absent",
            headerName: "Absent",
            flex: 0.6,
            minWidth: 80,
            align: "center",
            headerAlign: "center",
        },
    ];

    const formattedAttendanceData = attendanceReportData.map((item, index) => ({
        id: index + 1,

        name: item.EXECUTIVENAME,

        // Day columns
        ...Array.from({ length: 31 }, (_, i) => ({
            [`day${i + 1}`]: item[i + 1] || "-"
        })).reduce((acc, curr) => ({ ...acc, ...curr }), {}),

        present: item.PRESENT || 0,
        leave: item.LEAVE || 0,
        absent: item.ABSENT || 0,
    }));

    const handleChange = (event, newValue) => {
        setValue(newValue);
        // Reset all tabs data
        setDate([]);
        setSelectedDate(null);
        setAnchorDate(null);
        setLeaveTypeRadio({});
        setLeaveTypeRadio({});
        setFromDateLeave(null);
        setToDateLeave(null);
        setRemark("");
        setLeavePaid(null); // or default

        handleLeaveRequestReset();
        handleLeaveHistoryReset();
        handleMyTeamReset();
        handleAttendanceReportReset();
        handleLeaveBalanceReportReset();

        // Load only the selected tab's default API
        loadTabDefaultData(newValue);
    };

    const handleExecutiveDdl = (newValue) => {
        setExecutiveDdl(newValue?.Id || "");
    };

    // Apply for leave
    const getImpactData = (datesArray) => {

        const payload = {

            loggedUserID: userId,

            Date: datesArray
                .map((d) => format(d, "dd-MMM-yyyy"))
                .join(","),

        };

        URLS.getTeamImpactLeaveData(payload)

            .then((response) => {

                setTeamImpactLeaveData(
                    Array.isArray(response.data)
                        ? response.data
                        : []
                );

            })

            .catch(() => {

                console.log("Error");

            });

        URLS.getProjectImpactLeaveData(payload)

            .then((response) => {

                setProjectImpactLeaveData(
                    Array.isArray(response.data)
                        ? response.data
                        : []
                );

            });

    };

    const handleDate = (newDate) => {
        if (!newDate) return;

        // Prevent selecting Sunday
        if (getDay(newDate) === 0) return;
        let updatedDates = [...date];

        // SHIFT or CTRL => select range
        if ((isShiftPressed || isCtrlPressed) && anchorDate) {

            const range = eachDayOfInterval({
                start: anchorDate < newDate ? anchorDate : newDate,
                end: anchorDate > newDate ? anchorDate : newDate,
            });

            range.forEach((d) => {
                if (getDay(d) === 0) return;

                if (!updatedDates.some((x) => isSameDay(x, d))) {
                    updatedDates.push(d);
                }
            });
        } else {
            // Normal click
            const exists = updatedDates.some((d) => isSameDay(d, newDate));

            if (!exists) {
                updatedDates.push(newDate);
            }

            // Save first clicked date
            setAnchorDate(newDate);
        }

        updatedDates.sort((a, b) => a - b);

        setDate(updatedDates);

        const payload = {
            loggedUserID: userId,
            Date: updatedDates
                .map((d) => format(d, "dd-MMM-yyyy"))
                .join(","),
        };

        Promise.all([
            URLS.getTeamImpactLeaveData(payload),
            URLS.getProjectImpactLeaveData(payload),
        ])
            .then(([teamResponse, projectResponse]) => {
                setTeamImpactLeaveData(
                    Array.isArray(teamResponse.data) ? teamResponse.data : []
                );

                setProjectImpactLeaveData(
                    Array.isArray(projectResponse.data) ? projectResponse.data : []
                );
            })
            .catch((error) => {
                console.error("Error fetching leave impact data:", error);
            });
    };

    console.log("TeamImpactLeaveData", teamImpactLeaveData, leaveTypeDdl, "date>>>>>>>>>>>>>>>", date, editModalData)
    const getLeaveHistory = (date) => {

        const monthStart = startOfMonth(date);
        const monthEnd = endOfMonth(date);

        const leaveHistoryPayload = {
            loggedUserID: userId,
            FromDate: format(monthStart, "dd-MMM-yyyy"),
            ToDate: format(monthEnd, "dd-MMM-yyyy"),
            LeaveType: leaveType || 0,
        };

        URLS.leaveHistoryData(leaveHistoryPayload)
            .then((response) => {
                setLeaveHistory(Array.isArray(response.data) ? response.data : []);

            })
            .catch((error) => {
                console.log("Error");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const getHolidayList = (date) => {
        const formattedYear = format(date, "yyyy");
        const month = format(date, "MM");

        URLS.getYearlyListOfHolidays({
            Year: formattedYear,
            Month: month,
        })
            .then((response) => {
                setHolidayList(
                    Array.isArray(response.data)
                        ? response.data
                        : []
                );
            })
            .catch(() => {
                setHolidayList([]);
            });
    };
    //const handleDate = (newDate) => {
    //    if (!newDate) return;

    //    const formatted = format(newDate, "yyyy-MMM-dd");

    //    setDate((prev) => {
    //        const exists = prev.some(
    //            (d) => format(d, "yyyy-MMM-dd") === formatted
    //        );

    //        const updatedDates = exists
    //            ? prev.filter((d) => format(d, "yyyy-MMM-dd") !== formatted)
    //            : [...prev, newDate];

    //        const payload = {
    //            loggedUserID: userId,
    //            Date: updatedDates.map(d => format(d, "yyyy-MMM-dd"))
    //        };

    //        console.log("Payload >>>", payload);

    //        URLS.getTeamImpactLeaveData(payload)
    //            .then((response) => {
    //                setTeamImpactLeaveData(Array.isArray(response.data) ? response.data : []);
    //            });
    //        URLS.getProjectImpactLeaveData(payload)
    //            .then((response) => {
    //                setProjectImpactLeaveData(Array.isArray(response.data) ? response.data : []);
    //            });

    //        return updatedDates;
    //    });
    //};

    const selectedImpactDate = date.length > 0 ? format(date[date.length - 1], "dd-MM-yyyy") : "";

    const handleRemark = (event) => {
        setRemark(event.target.value)
    };
    const resetApplyForLeaveForm = () => {
        setDate([]);
        setLeaveTypeRadio({});
        setFromDateLeave(null);
        setToDateLeave(null);
        setRemark("");
        setLeavePaid(null); // or default
        setLeaveTypeDdl(leaveOptions[0]); // default = Leave
    };

    const handleApplyForLeave = () => {

        //// 1. Leave Type
        if (isManager) {
            if (!executiveDdl) {
                enqueueSnackbar("Please select Executive.", { variant: "error" });
                return;
            }
        }
        if (!leaveTypeDdl || leaveTypeDdl.Id === undefined) {
            enqueueSnackbar("Please select leave type.", { variant: "error" });
            return;
        }

        //// 2. Normal Leave
        if (leaveTypeDdl.Id === 0) {
            if (!date || date.length === 0) {
                enqueueSnackbar("Please select at least one leave date.");
                return;
            }
            const missingDates = date.filter((d) => {
                const formattedDate = format(d, "dd-MMM-yyyy");
                return leaveTypeRadio[formattedDate] === undefined;
            });

            if (missingDates.length > 0) {
                const firstMissingDate = format(missingDates[0], "dd-MMM-yyyy");

                enqueueSnackbar(
                    `Select leave type for date: ${firstMissingDate}`,

                );
                return;
            }
        }

        //// 3. Long Leave
        if (leaveTypeDdl.Id === 1) {
            if (!fromDateLeave) {
                enqueueSnackbar("Please select From Date.",);
                return;
            }

            if (!toDateLeave) {
                enqueueSnackbar("Please select To Date.");
                return;
            }
            if (Moment(fromDateLeave).isAfter(Moment(toDateLeave), "day")) {
                enqueueSnackbar("From Date cannot be greater than To Date.", {
                    variant: "error",
                });
                return;
            }
        };
        const plainText = remark
            ?.replace(/<[^>]*>/g, "")
            ?.trim();

        if ((leaveTypeDdl.Id === 0 || leaveTypeDdl.Id === 1) && !plainText) {
            enqueueSnackbar("Please enter Remark.");
            return; // Prevent API call
        };
        setIsLoading(true);

        const leaveDetails = date.map((d) => {
            const formattedDate = format(d, "dd-MMM-yyyy");

            return {
                LeaveDate: formattedDate,
                LeaveType: leaveTypeRadio[formattedDate],
                IsApproved: false,
                Remarks: "",
                IsFirstHalf: 0,
                LeaveDetailsId: 0
            };
        });

        const isPaid = leavePaid?.Id === 1;

        const leavePayload = {
            EmployeeId: executiveDdl || userId,
            LeaveId: 0,
            ApprovedById: 0,
            LongLeaveTypes: "",
            Remarks: remark || "",
            PaidUnpaid: isPaid,
            FromDate: "",
            ToDate: "",
            LongLeaveRemarks: "",
            LeaveDetails: leaveDetails
        };


        const longLeavePayload = {
            UserID: executiveDdl || userId,
            Id: 0,
            IsPiad: isPaid,
            FromDate: fromDateLeave ? Moment(fromDateLeave).format("DD-MMM-YYYY") : "",
            ToDate: toDateLeave ? Moment(toDateLeave).format("DD-MMM-YYYY") : "",
            Remarks: remark || "",
        };

        if (leaveTypeDdl.Id === 0) {
            URLS.saveLeave(leavePayload)
                .then((response) => {
                    // enqueueSnackbar("Leave applied successfully.", { variant: "success" });
                    setOpenSuccess(true);

                })
                .catch((error) => {

                    console.log("Error:", error);
                    console.log("Error Response:", error.response);
                    console.log("Error Data:", error.response?.data);

                    const message =
                        error.response?.data?.Message ||
                        error.response?.data?.[0]?.Message ||
                        "Failed to apply leave. Please try again.";

                    enqueueSnackbar(message, {
                        variant: "error",
                    });
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
        // Call long leave only if needed
        if (leaveTypeDdl?.Id === 1) {
            URLS.saveLongLeave(longLeavePayload)
                .then((response) => {
                    if (response.status === 200) {
                        // enqueueSnackbar("Long leave submitted successfully.", { variant: "success" });
                        setOpenSuccess(true);

                    }
                })
                .catch((error) => {

                    console.log("Error:", error);
                    console.log("Error Response:", error.response);
                    console.log("Error Data:", error.response?.data);

                    const message =
                        error.response?.data?.Message ||
                        error.response?.data?.[0]?.Message ||
                        "Failed to apply leave. Please try again.";

                    enqueueSnackbar(message, {
                        variant: "error",
                    });
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    };

    const handleSuccessClose = () => {
        setOpenSuccess(false);       // close modal
        resetApplyForLeaveForm();    // reset form
        URLS.getPastLeaveData({ "loggedUserID": userId })
            .then((response) => {
                setPastLeaveData(Array.isArray(response.data?.PastLeaves) ? response.data?.PastLeaves : []);
                setUpcomingLeaveData(Array.isArray(response.data?.UpcomingLeaves) ? response.data?.UpcomingLeaves : []);
                console.log("past>>>>>>", response.data, response.data.PastLeaves)

            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
    };

    console.log("leaveHistoryData", leaveHistoryData)
    const handleLeaveTypeRadio = (e, selectedDate) => {

        const selectedValue = Number(e.target.value);
        const formattedDate = format(selectedDate, "dd-MMM-yyyy");

        const isLeaveApplied = leaveHistoryData.some(item =>
            item.LeaveDate
                ?.split(",")
                .map(date => date.trim())
                .includes(formattedDate)
        );

        if (isLeaveApplied && !isEditMode) {
            enqueueSnackbar("Leave already applied for this date.", {
                variant: "error",
            });
            return;
        }
        // Saturday Off Id check
        const saturdayOffId = 4;

        // Check selected date is Saturday or not
        const isSaturday = format(selectedDate, "EEEE") === "Saturday";

        if (selectedValue === saturdayOffId && !isSaturday) {

            enqueueSnackbar(
                "Saturday Off can only be selected for Saturday.",
                { variant: "error" }
            );

            return;
        }
        setLeaveTypeRadio((prev) => ({
            ...prev,
            [formattedDate]: selectedValue,
        }));
    };

    const handleDeleteDate = (indexToRemove) => {
        setDate((prev) => prev.filter((_, i) => i !== indexToRemove));

        // optional: also remove that date’s radio selection
        setLeaveTypeRadio((prev) => {
            const updated = { ...prev };
            const removedDate = format(date[indexToRemove], "dd-MMM-yyyy");
            delete updated[removedDate];
            return updated;
        });
    };
    const handleLongLeaveFromDate = (newValue) => {
        setFromDateLeave(newValue);
    };
    const handleLongLeaveToDate = (newValue) => {
        setToDateLeave(newValue);
    };
    //Leave History Type
    const handleFromDate = (newValue) => {
        setFromDate(newValue);
    };
    const handleToDate = (newValue) => {
        setToDate(newValue);
    };
    const handleLeaveType = (newValue) => {
        setLeaveType(newValue?.Id || "");
    };
    const handleExecutiveHistory = (newValue) => {
        setExecutiveHistory(newValue?.Id || "");
    };
    const handleFilterLeaveHistory = () => {
        if (fromDate && toDate && Moment(fromDate).isAfter(Moment(toDate), "day")) {
            enqueueSnackbar("From Date cannot be greater than To Date.", {
                variant: "error",
            });
            return;
        }

        setIsLoading(true);

        const payload = {
            loggedUserID: executiveHistory || userId,
            FromDate: fromDate ? Moment(fromDate).format("DD-MMM-YYYY") : null,
            ToDate: toDate ? Moment(toDate).format("DD-MMM-YYYY") : null,
            LeaveType: leaveType || 0,
        };

        URLS.leaveHistoryData(payload)
            .then((response) => {
                setLeaveHistoryData(Array.isArray(response.data) ? response.data : []);
                enqueueSnackbar("Leave history fetched successfully.", {
                    variant: "success",
                });


            })
            .catch((error) => {
                enqueueSnackbar("No leave history records found.", {
                    variant: "error",
                });

                console.log(error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    console.log("leaveHistoryData", leaveHistoryData)
    const handleLeaveHistoryReset = () => {
        setFromDate(null);
        setToDate(null);
        setLeaveType("");
        setLeaveHistoryData([]);
        setViewLeaveHistoryData([]);
        setExecutiveHistory(userId);
    };
    const handleMenuOpen = (event, row) => {
        setAnchorEl(event.currentTarget);
        setSelectedRow(row);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };
    const handleViewLeaveHistoryCloseModal = () => {
        setViewLeaveHistoryModal(false);

    };
    const handleViewLeaveHistoryOpenModal = (cellValues) => {
        console.log("cellValues", cellValues)
        setViewLeaveHistoryModal(true);
        setViewLeaveHistoryData(cellValues);
        setAnchorEl(null);

    };

    const handleEditLeave = (row) => {
        if (!row?.LeaveDate) return;

        const parsedDates = row.LeaveDate
            .split(",")
            .map((dateStr) => {
                const parsed = parse(
                    dateStr.trim(),
                    "dd-MMM-yyyy",
                    new Date()
                );

                return isValid(parsed)
                    ? startOfDay(parsed)
                    : null;
            })
            .filter(Boolean);

        // Set selected radio button
        //const radioData = {};

        //parsedDates.forEach((d) => {
        //    radioData[format(d, "dd-MMM-yyyy")] =
        //        row.LeaveTypeID;
        //});

        //setLeaveTypeRadio(radioData);

        const leaveTypeIds = row.LeaveTypeID
            ?.split(",")
            .map(item => Number(item.trim())) || [];

        const radioData = {};

        parsedDates.forEach((d, index) => {
            radioData[format(d, "dd-MMM-yyyy")] = leaveTypeIds[index];
        });

        setLeaveTypeRadio(radioData);

        // API Payload
        const payload = {
            loggedUserID: userId,
            Date: parsedDates
                .map((d) => format(d, "dd-MMM-yyyy"))
                .join(","),
        };

        console.log("payload>>>>>>>>", payload);

        // Team Impact API
        URLS.getTeamImpactLeaveData(payload)
            .then((response) => {
                setTeamImpactLeaveData(
                    Array.isArray(response.data)
                        ? response.data
                        : []
                );

                console.log(
                    "team impact>>>>>>>>",
                    response.data
                );
            })
            .catch((error) => {
                console.log("Team Impact Error", error);
            });

        // Project Impact API
        URLS.getProjectImpactLeaveData(payload)
            .then((response) => {
                setProjectImpactLeaveData(
                    Array.isArray(response.data)
                        ? response.data
                        : []
                );

                console.log(
                    "project impact>>>>>>>>",
                    response.data
                );
            })
            .catch((error) => {
                console.log("Project Impact Error", error);
            });

        setEditModalData({
            ID: row.ID || 0,
            EntryDate: row.EntryDate || "",
            dates: parsedDates,
            remark: row.LeaveRemarks || "",
            executiveId: row.ExecutiveID || null,
            LeaveDetailsId: row.LeaveDetailsId || "",
        });

        setEditModalOpen(true);
        setAnchorEl(null);

    };

    const handleCancel = (cellValues) => {
        console.log("cellValues>>>>>", cellValues)
        setIsLoading(true);

        const cancelPayload = {
            "ExecutiveId": cancelModalData?.ExecutiveID || 0,
            "LeaveId": cancelModalData?.ID || 0
        };
        const payload = {
            "loggedUserID": executiveHistory || userId,
            "FromDate": fromDate ? Moment(fromDate).format("DD-MMM-YYYY") : null,
            "ToDate": toDate ? Moment(toDate).format("DD-MMM-YYYY") : null,
            "LeaveType": leaveType || 0,
        }
        URLS.cancelLeaveRequest(cancelPayload)
            .then((response) => {
                // setLeaveHistoryData(Array.isArray(response.data) ? response.data : []);

                URLS.leaveHistoryData(payload)
                    .then((response) => {
                        setLeaveHistoryData(Array.isArray(response.data) ? response.data : []);

                    })
                    .catch(error => {
                        // On error

                        console.log(" Error ");
                    });

                enqueueSnackbar("Leave cancelled successfully.", { variant: "success" });

            })
            .catch(error => {
                // On error
                setIsLoading(false);
                enqueueSnackbar("Failed to cancel leave. Please try again.", { variant: "error" });
                console.log(" Error ");
            })
            .finally(() => {
                setIsLoading(false);
            });

    };
    console.log("date>>>>>>>>>>>", date)
    const handleCancelConfirm = () => {
        if (selectedRow) {
            handleCancel(selectedRow); // pass row
        };

        setCancelModal(false);
    };
    const handleCancelClick = () => {
        setCancelModal(false);
    };
    const handleOpenCancelModal = (cellValues) => {
        console.log("cancel", cellValues)
        setCancelModalData(cellValues);
        setCancelModal(true);
        setAnchorEl(null);

    };
    const handleEditDate = (newDate) => {
        if (!newDate) return;

        const normalizedDate = startOfDay(newDate);

        setEditModalData((prev) => {
            const alreadyExists = prev.dates.some(
                (d) =>
                    format(d, "dd-MMM-yyyy") ===
                    format(normalizedDate, "dd-MMM-yyyy")
            );

            return {
                ...prev,
                dates: alreadyExists
                    ? prev.dates.filter(
                        (d) =>
                            format(d, "dd-MMM-yyyy") !==
                            format(normalizedDate, "dd-MMM-yyyy")
                    )
                    : [...prev.dates, normalizedDate]
            };
        });

    };
    const handleEditOpenModal = () => {
        setEditModalOpen(true);
    };
    const handleEditCloseModal = () => {
        setEditModalOpen(false);
    };
    //const handleEditDate = (newDate) => {
    //    if (!newDate) return;

    //    setEditModalData((prev) => ({
    //        ...prev,
    //        dates: [newDate], // only one date
    //    }));
    //};
    const handleEditRemark = (event) => {
        setEditModalData((prev) => ({
            ...prev,
            remark: event.target.value,
        }));
    };
    console.log("editModalData", editModalData);
    console.log(editModalData?.LeaveDetailsId);
    const handleUpdateLeave = () => {

        //// 1. Leave Type
        if (isManager) {
            if (!executiveDdl) {
                enqueueSnackbar("Please select Executive.", {
                    variant: "error"
                });
                return;
            }
        }

        if (!leaveTypeDdl || leaveTypeDdl.Id === undefined) {
            enqueueSnackbar("Please select leave type.", {
                variant: "error"
            });
            return;
        }

        //// 2. Normal Leave Validation
        if (leaveTypeDdl.Id === 0) {

            if (!editModalData?.dates || editModalData.dates.length === 0) {
                enqueueSnackbar(
                    "Please select at least one leave date.",
                    { variant: "error" }
                );
                return;
            }

            const missingDates = editModalData.dates.filter((d) => {

                const formattedDate = format(d, "dd-MMM-yyyy");

                return leaveTypeRadio[formattedDate] === undefined;
            });

            if (missingDates.length > 0) {

                const firstMissingDate = format(
                    missingDates[0],
                    "dd-MMM-yyyy"
                );

                enqueueSnackbar(
                    `Select leave type for date: ${firstMissingDate}`,
                    { variant: "error" }
                );

                return;
            }
        }

        //// 3. Long Leave Validation
        if (leaveTypeDdl.Id === 1) {

            if (!fromDateLeave) {
                enqueueSnackbar("Please select From Date.", {
                    variant: "error"
                });
                return;
            }

            if (!toDateLeave) {
                enqueueSnackbar("Please select To Date.", {
                    variant: "error"
                });
                return;
            }
        }

        setIsLoading(true);

        //// Leave Details
        const leaveDetailsIds = editModalData.LeaveDetailsId?.split(",").map(x => x.trim()) || [];
        const leaveTypeIds = editModalData.LeaveTypeID?.split(",").map(x => Number(x.trim())) || [];

        const leaveDetails = editModalData?.dates?.map((d, index) => {
            const formattedDate = format(d, "dd-MMM-yyyy");

            return {
                LeaveDate: formattedDate,
                // Use edited value if available, otherwise use the original value for that date
                LeaveType:
                    leaveTypeRadio[formattedDate] !== undefined
                        ? leaveTypeRadio[formattedDate]
                        : leaveTypeIds[index],
                IsApproved: false,
                Remarks: "",
                IsFirstHalf: 0,
                LeaveDetailsId: leaveDetailsIds[index] || "",
            };
        });
        const historyPayload = {
            "loggedUserID": userId,
            "FromDate": fromDate ? Moment(fromDate).format("DD-MMM-YYYY") : null,
            "ToDate": toDate ? Moment(toDate).format("DD-MMM-YYYY") : null,
            "LeaveType": leaveType || 0,
        }
        const isPaid = leavePaid?.Id === 1;

        //// Leave Payload
        const leavePayload = {
            EmployeeId: executiveDdl || userId,
            LeaveId: editModalData?.ID || 0,
            ApprovedById: 0,
            LongLeaveTypes: "",
            Remarks: editModalData?.remark || "",
            PaidUnpaid: isPaid,
            FromDate: "",
            ToDate: "",
            LongLeaveRemarks: "",
            LeaveDetails: leaveDetails,
            IsEdit: 1
        };

        //// Long Leave Payload
        const longLeavePayload = {
            UserID: executiveDdl || userId,
            Id: editModalData?.ID || 0,
            IsPiad: isPaid,
            FromDate: fromDateLeave
                ? Moment(fromDateLeave).format("DD-MMM-YYYY")
                : "",
            ToDate: toDateLeave
                ? Moment(toDateLeave).format("DD-MMM-YYYY")
                : "",
            Remarks: editModalData?.remark || "",
        };

        //// Normal Leave Save/Update
        if (leaveTypeDdl.Id === 0) {

            URLS.saveLeave(leavePayload)

                .then((response) => {

                    setOpenSuccess(true);
                    setEditModalOpen(false);
                    URLS.leaveHistoryData(historyPayload)
                        .then((response) => {
                            setLeaveHistoryData(Array.isArray(response.data) ? response.data : []);

                        })
                        .catch(error => {
                            // On error

                            console.log(" Error ");
                        })
                        .finally(() => {
                            setIsLoading(false);
                        });
                })

                .catch((error) => {

                    enqueueSnackbar(
                        "Failed to update leave. Please try again.",
                        { variant: "error" }
                    );

                })
                .finally(() => {
                    setIsLoading(false);
                });
        }

        //// Long Leave Save/Update
        if (leaveTypeDdl?.Id === 1) {

            URLS.saveLongLeave(longLeavePayload)

                .then((response) => {

                    if (response.status === 200) {

                        setOpenSuccess(true);
                        setEditModalOpen(false);
                        URLS.leaveHistoryData(historyPayload)
                            .then((response) => {
                                setLeaveHistoryData(Array.isArray(response.data) ? response.data : []);

                            })
                            .catch(error => {
                                // On error

                                console.log(" Error ");
                            })
                            .finally(() => {
                                setIsLoading(false);
                            });
                        
                    }
                })

                .catch(() => {

                    enqueueSnackbar(
                        "Failed to submit long leave.",
                        { variant: "error" }
                    );

                   

                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    };
    // My Team
    const handleMyTeamFromDate = (newValue) => {
        setMyTeamFromDate(newValue);
    };
    const handleMyTeamToDate = (newValue) => {
        setMyTeamToDate(newValue);
    };
    const handleExecutive = (newValue) => {
        setExecutive(newValue?.Id ?? "");

    };
    const handleDepartment = (newValue) => {
        setDepartment(newValue?.Id || "");
    };
    const handleMyTeamLeaveType = (newValue) => {
        setMyTeamLeaveType(newValue?.Id || "");
    };

    const handleTeam = (newValue) => {
        setTeam(newValue?.Id || "");
    };
    const handleMyTeamFilter = () => {

        if (
            myTeamFromDate &&
            myTeamToDate &&
            Moment(myTeamFromDate).isAfter(Moment(myTeamToDate), "day")
        ) {
            enqueueSnackbar("From Date cannot be greater than To Date.", {
                variant: "error",
            });
            return;
        }

        setIsLoading(true);

        const payload = {
            UserID: userId || 0,
            IsApprove: 0,
            StartDate: myTeamFromDate || "",
            IsChildren: 0,
            LeaveDate: "",
            ExecutiveId: executive || 0,
            Status: myTeamleaveType || "",
            ProjectId: team || 0,
            DepartmentID: department || 0,
            FromDate: myTeamFromDate
                ? Moment(myTeamFromDate).format("DD-MMM-YYYY")
                : "",
            ToDate: myTeamToDate
                ? Moment(myTeamToDate).format("DD-MMM-YYYY")
                : "",
        };

        URLS.getLeaveApprovalData(payload)
            .then((response) => {
                setMyTeamData(Array.isArray(response.data) ? response.data : []);
                enqueueSnackbar("Executive Availability records fetched successfully.", {
                    variant: "success",
                });
               
            })
            .catch((error) => {
                enqueueSnackbar("Failed to fetch Executive Availability records.", {
                    variant: "error",
                });
                setMyTeamData([]);
                
                console.log(error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const handleMyTeamReset = () => {
        setMyTeamFromDate(null);
        handleMyTeamToDate(null);
        setExecutive(userId || "");
        setDepartment("");
        setMyTeamLeaveType("");
        setTeam("");
        setMyTeamData([]);
    };

    // AttendanceReport
    const handleMonthYear = (newValue) => {
        setMonthYear(newValue);
    };
    const handleAttendanceReportFilter = () => {
        setIsLoading(true);
        const payload = {
            "LoginId": userId,
            "IsAll": executive === 0,
            "ExecutiveId": executive || 0,
            "Month": monthYear
                ? Moment(monthYear).format("MM-YYYY")
                : ""
        };
        URLS.getMonthlyAttendanceReport(payload)
            .then((response) => {
                setAttendanceReportData(Array.isArray(response.data) ? response.data : []);
                enqueueSnackbar("Attendance report fetched successfully.", { variant: "success" });
               
            })
            .catch(error => {
                enqueueSnackbar("No attendance data found.", { variant: "error" });
               
                // On error
                console.log(" Error ");
            })
            .finally(() => {
                setIsLoading(false);
            });

    };
    const handleAttendanceReportReset = () => {
        const defaultMonth = new Date();

        setMonthYear(defaultMonth);
        setExecutive(userId);
        setIsLoading(true);

        const payload = {
            LoginId: userId,
            IsAll: false,
            ExecutiveId: userId,
            Month: Moment(defaultMonth).format("MM-YYYY"),
        };

        URLS.getMonthlyAttendanceReport(payload)
            .then((response) => {
                setAttendanceReportData(
                    Array.isArray(response.data) ? response.data : []
                );

            })
            .catch((error) => {

                console.log("Error", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };
    // leave balance report 
    const handleLeaveReportExecutive = (newValue) => {
        setLeaveReportExecutive(newValue?.Id ?? "");
    };
    const handleNoOfMonths = (e) => {
        setNoOfMonths(e.target.value);
    };
    const handleLeaveBalanceReportFilter = () => {
        setIsLoading(true);
        const isAllExecutive = executive === 0;
        const formattedMonth =
            monthYear
                ? Moment(monthYear).format("MM-YYYY")
                : "";

        const payload = {
            "IsAllExecutives": leaveReportExecutive === 0,
            "ExecutiveId": leaveReportExecutive,
            "Month": formattedMonth,
            "NoOfMonths": noOfMonths || 0,
        };
        URLS.getLeaveBalanceReport(payload)
            .then((response) => {
                console.log("bal>>>", response.data, response)
               

                setLeaveBalanceReportData(Array.isArray(response.data) ? response.data : []);
                enqueueSnackbar("Leave Balance Report fetched successfully.", { variant: "success" });

            })
            .catch(error => {
                enqueueSnackbar("No data found.", { variant: "error" });
              

                // On error
                console.log(" Error ");
            }).finally(() => {
                setIsLoading(false);
            });

    };

    const handleLeaveBalanceReportReset = () => {
        setLeaveReportExecutive(userId);
        setNoOfMonths("");
        setMonthYear(new Date());
        setLeaveBalanceReportData([]);
    };
    // leave request
    const handleRequestExecutive = (newValue) => {
        setRequestExecutive(newValue?.Id || "");
    };
    const handleRequestProject = (newValue) => {
        setRequestProject(newValue?.Id || "");
    };
    const handleRequestStatus = (newValue) => {
        setRequestStatus(newValue?.Id || "");
    };
    const handleRequestDepartment = (newValue) => {
        setRequestDepartment(newValue?.Id || "");
    };
    const handleLeaveRequestFilter = () => {
        setIsLoading(true);
        const payload =
        {
            "UserID": userId || 0,
            "IsApprove": 1,
            "StartDate": "",
            "IsChildren": 0,
            "LeaveDate": "",
            "ExecutiveId": requestExecutive || 0,
            "Status": requestStatus || "",
            "ProjectId": requestProject || 0,
            "DepartmentID": requestDepartment || 0,
            "FromDate": myTeamFromDate
                ? Moment(myTeamFromDate).format("DD-MMM-YYYY")
                : "",
            "ToDate": myTeamToDate
                ? Moment(myTeamToDate).format("DD-MMM-YYYY")
                : "",

        }
        URLS.getLeaveApprovalData(payload)
            .then((response) => {
                setLeaveRequestData(Array.isArray(response.data) ? response.data : []);
                enqueueSnackbar("Leave requests fetched successfully.", { variant: "success" });
               
            })
            .catch(error => {
                enqueueSnackbar("Failed to fetch leave requests.", { variant: "error" });
               
                // On error
                console.log(" Error ");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const handleLeaveRequestReset = () => {
        setRequestExecutive("");
        setRequestProject("");
        setRequestStatus(selectedRequestStatus[0]?.Id);
        setRequestDepartment("");
        setLeaveRequestData([]);
        setIsView(false);
        setRejectModal(false);
        setApproveModal(false);
        setLeaveRequestAnchorEl(null);

    };
    console.log("leaveRequestData:", leaveRequestData);
    const handleViewClick = (row) => {
        console.log("params>>>>>>>>>", row);
        setProcessedCards({});
        if (!row) return;

        setSelectedRequestRow(row);
        setIsView(true);
        setLeaveRequestAnchorEl(null);

        // Convert LeaveDate string into array
        const datesArray = row?.LeaveDate
            ? row?.LeaveDate.split(",")
            : [];

        const payload = {
            loggedUserID: userId,
            Date: datesArray.join(",")
        };

        URLS.getTeamImpactLeaveData(payload)
            .then((response) => {
                setTeamImpactLeaveData(
                    Array.isArray(response.data)
                        ? response.data
                        : []
                );
            })
            .catch(() => {
                console.log("Error");
            });

        URLS.getProjectImpactLeaveData(payload)
            .then((response) => {
                setProjectImpactLeaveData(
                    Array.isArray(response.data)
                        ? response.data
                        : []
                );
            })
            .catch(() => {
                console.log("Error");
            });
    };

    const handleLeaveRequestApprove = (row) => {
        setSelectedRequestRow(row);
        setApproveModal(true);
        setLeaveRequestAnchorEl(null);
    };
    const handleApproveCloseModal = () => {
        setApproveModal(false);
    };
    const handleLeaveRequestReject = (row) => {
        setSelectedRequestRow(row);
        setRejectModal(true);
        setLeaveRequestAnchorEl(null);
    };
    const handleRejectCloseModal = () => {
        setRejectModal(false);
    };
    console.log("selectedRequestRow", selectedRequestRow)

    const handleApprove = () => {
        const leaveDetailsIds = String(selectedRequestRow?.LeaveDetailsId || "")
            .split(",")
            .map(id => id.trim())
            .filter(Boolean);

        const payload = {
            ApprovedById: userId || 0,
            ApprovalDetails: leaveDetailsIds.map(id => ({
                LeaveId: selectedRequestRow?.ID || 0,
                LeaveDetailsId: Number(id),
                ApprovalType: 1,
                LeaveDetailsRemarks: selectedRequestRow?.LeaveRemarks || "",
            }))
        };
        const leaveRequestPayload =
        {
            "UserID": userId || 0,
            "IsApprove": 1,
            "StartDate": "",
            "IsChildren": 0,
            "LeaveDate": "",
            "ExecutiveId": requestExecutive || 0,
            "Status": requestStatus || "",
            "ProjectId": requestProject || 0,
            "DepartmentID": requestDepartment || 0,
            "FromDate": myTeamFromDate ? Moment(myTeamFromDate).format("DD-MMM-YYYY") : "",
            "ToDate": myTeamToDate ? Moment(myTeamToDate).format("DD-MMM-YYYY") : "",
        }

        URLS.approveLeave(payload)
            .then(() => {
                enqueueSnackbar("Leave request approved successfully.", { variant: "success" });
                URLS.getLeaveApprovalData(leaveRequestPayload)
                    .then((response) => {
                        setLeaveRequestData(Array.isArray(response.data) ? response.data : []);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
                setApproveModal(false);
                // handleLeaveRequestReset();
            })
            .catch((error) => {
                enqueueSnackbar("Failed to approve leave request.", { variant: "error" });
                console.log(error);
            });
    };

    const handleLeaveAction = (leaveDetailsId, approvalType) => {
        const payload = {
            ApprovedById: userId || 0,
            ApprovalDetails: [
                {
                    LeaveId: selectedRequestRow?.ID || 0,
                    LeaveDetailsId: Number(leaveDetailsId),
                    ApprovalType: approvalType, // 1=Approve, 2=Reject, 3=Cancel
                    LeaveDetailsRemarks: selectedRequestRow?.LeaveRemarks || "",
                },
            ],
        };
        const leaveRequestPayload =
        {
            "UserID": userId || 0,
            "IsApprove": 1,
            "StartDate": "",
            "IsChildren": 0,
            "LeaveDate": "",
            "ExecutiveId": requestExecutive || 0,
            "Status": requestStatus || "",
            "ProjectId": requestProject || 0,
            "DepartmentID": requestDepartment || 0,
            "FromDate": myTeamFromDate ? Moment(myTeamFromDate).format("DD-MMM-YYYY") : "",
            "ToDate": myTeamToDate ? Moment(myTeamToDate).format("DD-MMM-YYYY") : "",
        }

        URLS.approveLeave(payload)
            .then(() => {
                const message =
                    approvalType === 1
                        ? "Leave approved successfully."
                        : approvalType === 2
                            ? "Leave rejected successfully."

                            : "Leave cancelled successfully.";

                enqueueSnackbar(message, { variant: "success" });
                setProcessedCards(prev => ({
                    ...prev,
                    [leaveDetailsId]: approvalType,
                }));
                // handleLeaveRequestReset();
                URLS.getLeaveApprovalData(leaveRequestPayload)
                    .then((response) => {
                        setLeaveRequestData(Array.isArray(response.data) ? response.data : []);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            })
            .catch((error) => {
                enqueueSnackbar("Action failed.", { variant: "error" });
                console.error(error);
            });
    };
    const handleReject = () => {
        const payload = {
            ExecutiveId: selectedRequestRow?.ExecutiveID || 0,
            LeaveId: selectedRequestRow?.ID || 0,
        };
        const leaveRequestPayload =
        {
            "UserID": userId || 0,
            "IsApprove": 1,
            "StartDate": "",
            "IsChildren": 0,
            "LeaveDate": "",
            "ExecutiveId": requestExecutive || 0,
            "Status": requestStatus || "",
            "ProjectId": requestProject || 0,
            "DepartmentID": requestDepartment || 0,
            "FromDate": myTeamFromDate ? Moment(myTeamFromDate).format("DD-MMM-YYYY") : "",
            "ToDate": myTeamToDate ? Moment(myTeamToDate).format("DD-MMM-YYYY") : "",
        };
        URLS.rejectLeaveRequest(payload)
            .then((response) => {
                URLS.getLeaveApprovalData(leaveRequestPayload)
                    .then((response) => {
                        setLeaveRequestData(Array.isArray(response.data) ? response.data : []);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
                enqueueSnackbar("Leave request rejected successfully.", {
                    variant: "success"
                });
                setRejectModal(false);

                // handleLeaveRequestReset();
            })
            .catch((error) => {

                enqueueSnackbar("Failed to reject leave request.", {
                    variant: "error"
                });

                console.log("Error", error);
            });
    };

    const handleCancelLeave = (cellValues) => {

        console.log("cancel>>>>>", cellValues)
        setIsLoading(true);

        const cancelPayload = {
            ExecutiveId: selectedRequestRow?.ExecutiveID || 0,
            LeaveId: selectedRequestRow?.ID || 0,
        };
        URLS.cancelLeaveRequest(cancelPayload)
            .then((response) => {
                handleLeaveRequestReset();
                enqueueSnackbar("Leave cancelled successfully.", { variant: "success" });

            })
            .catch(error => {
                // On error
                enqueueSnackbar("Failed to cancel leave. Please try again.", { variant: "error" });
                console.log(" Error ");
            })
            .finally(() => {
                setIsLoading(false);
            });

    };

    const handleTeamFromDate = (newValue) => {
        const formattedDate = format(newValue, "dd-MMM-yyyy");

        setTeamFromDate(formattedDate);

        URLS.getLeaveCount({
            LoginId: userId,
            LeaveDate: formattedDate,
        })
            .then((response) => {
                setTeamPendingApprovalData(response.data);
                console.log("past>>>>>>", response.data, response.data.PastLeaves);
            })
            .catch((error) => {
                console.log("Error", error);
            });
    };
    const handleProjectTeamFromDate = (newValue) => {
        const formattedDate = format(newValue, "dd-MMM-yyyy");

        setProjectTeamFromDate(formattedDate);

        URLS.getProjectTeamAvailabilityData({
            loggedUserID: userId,
            Date: formattedDate,
        })
            .then((response) => {
                setPendingApprovalData(response.data);
                console.log("past>>>>>>", response.data, response.data.PastLeaves);
            })
            .catch((error) => {
                console.log("Error", error);
            });
    };
    const handleLeaveRequestMenuOpen = (event, row) => {
        setLeaveRequestAnchorEl(event.currentTarget);
        setSelectedRequestRow(row);
    };
    const handleLeaveRequestMenuClose = () => {
        setLeaveRequestAnchorEl(null);
    };
    const loadLeaveRequestData = () => {
        const payload = {
            UserID: userId || 0,
            IsApprove: 1,
            StartDate: "",
            IsChildren: 0,
            LeaveDate: "",
            ExecutiveId: requestExecutive || 0,
            Status: requestStatus || "",
            ProjectId: requestProject || 0,
            DepartmentID: requestDepartment || 0,
            FromDate: myTeamFromDate
                ? Moment(myTeamFromDate).format("DD-MMM-YYYY")
                : "",
            ToDate: myTeamToDate
                ? Moment(myTeamToDate).format("DD-MMM-YYYY")
                : "",
        };

        URLS.getLeaveApprovalData(payload)
            .then((response) => {
                setLeaveRequestData(
                    Array.isArray(response.data) ? response.data : []
                );
                enqueueSnackbar("Leave requests fetched successfully.", { variant: "success" });

            })
            .catch((error) => {
                console.log("Leave Request Error", error);
            });

    };
    const loadApplyForLeaveData = () => {
        URLS.getPastLeaveData({ loggedUserID: userId })
            .then((response) => {
                setPastLeaveData(
                    Array.isArray(response.data?.PastLeaves)
                        ? response.data.PastLeaves
                        : []
                );

                setUpcomingLeaveData(
                    Array.isArray(response.data?.UpcomingLeaves)
                        ? response.data.UpcomingLeaves
                        : []
                );
            })
            .catch((error) => {
                console.log("Apply For Leave Error", error);
            });
    };
    const loadLeaveHistoryData = () => {
        const payload = {
            loggedUserID: executiveHistory || userId,
            FromDate: null,
            ToDate: null,
            LeaveType: leaveType || 0,
        };

        URLS.leaveHistoryData(payload)
            .then((response) => {
                setLeaveHistoryData(
                    Array.isArray(response.data) ? response.data : []
                );
                enqueueSnackbar("Leave history fetched successfully.", {
                    variant: "success",
                });
            })
            .catch((error) => {
                console.log("Leave History Error", error);
            });
    };
    const loadExecutiveAvailabilityData = () => {
        const payload = {
            UserID: userId || 0,
            IsApprove: 0,
            StartDate: "",
            IsChildren: 0,
            LeaveDate: "",
            ExecutiveId: executive || 0,
            Status: myTeamleaveType || "",
            ProjectId: team || 0,
            DepartmentID: department || 0,
            FromDate: myTeamFromDate
                ? Moment(myTeamFromDate).format("DD-MMM-YYYY")
                : "",
            ToDate: myTeamToDate
                ? Moment(myTeamToDate).format("DD-MMM-YYYY")
                : "",
        };

        URLS.getLeaveApprovalData(payload)
            .then((response) => {
                setMyTeamData(
                    Array.isArray(response.data) ? response.data : []
                );
                enqueueSnackbar("Executive Availability records fetched successfully.", {
                    variant: "success",
                });
            })
            .catch((error) => {
                console.log("Executive Availability Error", error);
            });
    };
    const loadAttendanceReportData = () => {
        const payload = {
            LoginId: userId,
            IsAll: executive === 0,
            ExecutiveId: executive || 0,
            Month: monthYear
                ? Moment(monthYear).format("MM-YYYY")
                : "",
        };

        URLS.getMonthlyAttendanceReport(payload)
            .then((response) => {
                setAttendanceReportData(
                    Array.isArray(response.data) ? response.data : []
                );
                enqueueSnackbar("Attendance report fetched successfully.", { variant: "success" });

            })
            .catch((error) => {
                console.log("Attendance Report Error", error);
            });
    };
    const loadLeaveBalanceReportData = () => {
        const payload = {
            IsAllExecutives: leaveReportExecutive === 0,
            ExecutiveId: leaveReportExecutive,
            Month: monthYear
                ? Moment(monthYear).format("MM-YYYY")
                : "",
            NoOfMonths: noOfMonths || 0,
        };

        URLS.getLeaveBalanceReport(payload)
            .then((response) => {
                setLeaveBalanceReportData(
                    Array.isArray(response.data) ? response.data : []
                );
            })
            .catch((error) => {
                console.log("Leave Balance Report Error", error);
            });
    };

    const loadTabDefaultData = (tabIndex) => {
        if (isManager) {
            switch (tabIndex) {
                case 0:
                    loadLeaveRequestData();
                    break;

                case 1:
                    loadApplyForLeaveData();
                    break;

                case 2:
                    loadLeaveHistoryData();
                    break;

                case 3:
                    loadExecutiveAvailabilityData();
                    break;

                case 4:
                    loadAttendanceReportData();
                    break;

                case 5:
                    loadLeaveBalanceReportData();
                    break;

                default:
                    break;
            }
        } else {
            switch (tabIndex) {
                case 0:
                    loadApplyForLeaveData();
                    break;

                case 1:
                    loadLeaveHistoryData();
                    break;

                case 2:
                    loadExecutiveAvailabilityData();
                    break;

                case 3:
                    loadAttendanceReportData();
                    break;

                case 4:
                    loadLeaveBalanceReportData();
                    break;

                default:
                    break;
            }
        }
    };

    useEffect(() => {
        URLS.getServiceEntryClientName()
            .then((response) => {

            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        //URLS.loadExecutives(userClientId)
        //    .then((response) => {
        //    })
        //    .catch(error => {
        //        // On error
        //        console.log(" Error ");
        //    });
        URLS.getExecutivesList()
            .then((response) => {
                setSelectedExecutive(Array.isArray(response.data) ? response.data : []);

                setSelectedLeaveReportExecutive(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getReportingExecutives({ loggedUserID: userId })
            .then((response) => {
                setSelectedExecutiveDdl(Array.isArray(response.data) ? response.data : []);
                setSelectedExecutiveHistory(Array.isArray(response.data) ? response.data : []);

            })

            .catch(error => {
                // On error
                console.log(" Error ");
            });

        URLS.getDepartmentDropDown()
            .then((response) => {
                setSelectedDepartment(response.data);
                setSelectedRequestDepartment(response.data);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.projectList()
            .then((response) => {
                // setSelectedtRequestProject(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getExecutiveData({ "ExecutiveID": userId })
            .then((response) => {
                setManagerDashboard(response.data);
                //  setSelectedExecutiveDdl(Array.isArray(response.data) ? response.data : []);
                setSelectedtRequestExecutive(Array.isArray(response.data) ? response.data : []);

                // console.log("response.data children", response.data)
            })
            .catch(error => {
                // On error
                console.log("Error");
            });
        URLS.getManagerList()
            .then((response) => {
                const managerList = Array.isArray(response.data) ? response.data : [];

                const isManager = managerList.some(
                    (item) => item.ReportingToId === userId
                );

                setIsManager(isManager);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });

        URLS.getEmployeeMonthlyLeaveData({ "loggedUserID": userId })
            .then((response) => {
                setLeaveBalanceData(response.data);
                console.log("past>>>>>>", response.data, response.data.PastLeaves)

            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getLeaveCount({
            LoginId: userId,
            LeaveDate: Moment(new Date()).format("DD-MMM-YYYY"),
        })
            .then((response) => {
                setTeamPendingApprovalData(response.data);
                console.log("past>>>>>>", response.data, response.data.PastLeaves)

            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getProjectTeamAvailabilityData({
            loggedUserID: userId,
            Date: Moment(new Date()).format("DD-MMM-YYYY"),
        })
            .then((response) => {
                setPendingApprovalData(response.data);
                console.log("past>>>>>>", response.data, response.data.PastLeaves)

            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });


        URLS.birthdayofexecutive()
            .then((response) => {
                console.log("birthday", response.data, response.data?.Executives)
                setBirthdayData(Array.isArray(response.data?.Executives) ? response.data?.Executives : []);

            })
            .catch(error => {

                // On error
                console.log(" Error ");
            });
        URLS.getMilestoneData()
            .then((response) => {
                setMilestonesData(Array.isArray(response.data) ? response.data : []);

            })
            .catch(error => {

                // On error
                console.log(" Error ");
            });
        URLS.getListOfHolidays()
            .then((response) => {
                setHolidayData(Array.isArray(response.data) ? response.data : []);

            })
            .catch(error => {

                // On error
                console.log(" Error ");
            });

        const monthStart = startOfMonth(new Date());
        const monthEnd = endOfMonth(new Date());


        URLS.getTeamNames()
            .then((response) => {
                setSelectedTeam(Array.isArray(response.data) ? response.data : []);
                setSelectedtRequestProject(Array.isArray(response.data) ? response.data : []);

            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getExecutiveLeaveBalance({ "LoginId": userId })
            .then((response) => {
                setClosingBalance(Array.isArray(response.data) ? response.data : []);

            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getMultipleDepartmenthierarchyId()
            .then((response) => {
                console.log("dept>>>>", response);
                const apiIds = String(response.data)
                    .split(",")
                    .map(id => Number(id.trim()));


                setDepartmentDropdownVisible(apiIds.includes(userId));
            })
            .catch((error) => {
                console.log("Error", error);
                setDepartmentDropdownVisible(false);
            });
    }, [])

    useEffect(() => {
        if (isManager !== null && isManager !== undefined) {
            setValue(0);
            loadTabDefaultData(0);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isManager]);

    console.log("userId", userId)

    useEffect(() => {
        if (!executiveDdl && selectedExecutiveDdl.length > 0 && userId) {
            const exists = selectedExecutiveDdl.some(x => x.Id === userId);
            if (exists) {
                setExecutiveDdl(userId);
            }
        }
    }, [executiveDdl, selectedExecutiveDdl, userId]);

    useEffect(() => {
        if (
            !executiveHistory && selectedExecutiveHistory.length > 0 && userId
        ) {
            const exists = selectedExecutiveHistory.some(
                x => Number(x.Id) === Number(userId)
            );

            if (exists) {
                setExecutiveHistory(userId);
            }
        }
    }, [selectedExecutiveHistory, userId, executiveHistory]);

    useEffect(() => {
        const handleKeyDown = (e) => {
            setIsShiftPressed(e.shiftKey);
            setIsCtrlPressed(e.ctrlKey || e.metaKey);
        };

        const handleKeyUp = (e) => {
            setIsShiftPressed(e.shiftKey);
            setIsCtrlPressed(e.ctrlKey || e.metaKey);
        };

        window.addEventListener("keydown", handleKeyDown);
        window.addEventListener("keyup", handleKeyUp);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
            window.removeEventListener("keyup", handleKeyUp);
        };
    }, []);

    console.log("balance>>>>>>>>>>>>>>>", leaveBalanceData, leaveBalanceData[0])
    const leaveData = [
        {
            label: "Leaves",
            count: leaveBalanceData?.TotalLeaves,
            icon: "material-symbols:task-alt",
            color: "#00A63E",
        },
        {
            label: "Absent",
            count: leaveBalanceData?.TotalAbsent,
            icon: "material-symbols:cancel-outline",
            color: "#FB2C36",
        },
        {
            label: "Remaining Leave",
            count: leaveBalanceData?.ClosingBalance,
            icon: "material-symbols:history",
            color: "#2B7FFF",
        },
    ];

    const leaveTypeColors = {
        "Leave": "#FB2C36",
        "HD(Post)": "#FACC15",
        "HD(Pre)": "#FFD966",
        "Travelling": "#2B7FFF",
        "Alternate Off": "#00A63E",
        "Saturday Off": "#9C27B0",
        "Work From Home": "#00BCD4",
    };

    const pieData = Object.values(
        leaveHistoryPieData.reduce((acc, item, index) => {

            const leaveType = item.LeaveType || "Unknown";

            if (!acc[leaveType]) {
                acc[leaveType] = {
                    id: index + 1,
                    label: leaveType,
                    value: 0,
                    color: leaveTypeColors[leaveType] || "#717883",
                };
            }

            acc[leaveType].value += Number(item.TotalDays || 1);

            return acc;

        }, {})
    );

    const leaveRequestApprovalData = [
        {
            label: "Pending Requests",
            count: pendingApprovalData?.[0]?.PendingCount || 0,
            icon: "material-symbols:task-alt",
            color: "#FAD601",
        },
        //{
        //    label: "Approved",
        //    count: pendingApprovalData?.[0]?.ApprovedCount || 0,
        //    icon: "material-symbols:cancel-outline",
        //    color: "#00A63E",
        //},
        //{
        //    label: "Rejected",
        //    count: pendingApprovalData?.[0]?.RejectedCount || 0,
        //    icon: "material-symbols:history",
        //    color: "#D93A46",
        //},
    ];

    const teamAvailabilityData = [
        {
            month: "Available",
            count: teamPendingApprovalData?.[0]?.AvailableCount || 0,
        },
        {
            month: "Leave",
            count: teamPendingApprovalData?.[0]?.PendingCount || 0,
        },
        {
            month: "WFH",
            count: teamPendingApprovalData?.[0]?.WFHCount || 0,
        },
    ];
    const projectTeamAvailabilityData = [
        {
            month: "Available",
            count: pendingApprovalData?.[0]?.AvailableCount || 0,
        },
        {
            month: "Leave",
            count: pendingApprovalData?.[0]?.PendingCount || 0,
        },
        {
            month: "WFH",
            count: pendingApprovalData?.[0]?.WFHCount || 0,
        },
    ];
    const offset = isManager ? 1 : 0;

    const isLeaveRequest = isManager && value === 0;
    const isApplyForLeave = value === (isManager ? 1 : 0);
    const isLeaveHistory = value === (isManager ? 2 : 1);
    const isMyTeam = value === (isManager ? 3 : 2);

    const showRightSection = !open && (isLeaveRequest || isLeaveHistory || isMyTeam);
    const isEditMode = Boolean(editModalData?.ID);
    console.log("isManager", isManager, isEditMode, editModalData?.ID, editModalData)

    const isOwnLeaveRequest = selectedRequestRow?.ExecutiveID === userId;

    return (
        <>
            <Page title="Leave Management | tiketic">
                <Grid container spacing={1}>
                    {/* LEFT COLUMN: Tabs and Content */}
                    <Grid item xs={12} md={showRightSection ? 9 : 12}>
                        {/* 1. The Tab Header Area */}
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: 2,
                            }}
                        >
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                <StyledTabs value={value} onChange={handleChange} variant="scrollable"
                                    scrollButtons="auto">
                                    {isManager && <StyledTab label="Leave Request" />}
                                    <StyledTab label="Apply For Leave" />
                                    <StyledTab label="Leave History" />
                                    <StyledTab label="Executive Availability" />
                                    <StyledTab label="Attendance Report" />
                                    <StyledTab label="Leave Balance Report" />
                                </StyledTabs>
                            </Box>

                            {isApplyForLeave && (
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                        flexShrink: 0,
                                    }}
                                >
                                    <Typography
                                        fontSize={14}
                                        fontWeight={500}
                                        color="#7B7B7B"
                                    >
                                        Closing Balance :
                                    </Typography>

                                    <Chip
                                        label={closingBalance?.[0]?.Closing ?? 0}
                                        size="small"
                                        sx={{
                                            borderRadius: "8px",
                                            bgcolor: "#FFFFFF",
                                            boxShadow: "0px 0px 2px 0px #0000002E",
                                        }}
                                    />
                                </Box>
                            )}
                        </Box>
                        {/* 2. The Main Content Box */}
                        <Box
                            sx={{
                                bgcolor: '#fff',
                                borderRadius: '0 8px 8px 8px',
                                border: '1px solid #e8e8e8',
                                height: 'calc(100vh - 180px)',
                                minHeight: '423px',
                                overflow: 'hidden',
                                width: open ? '95%' : '100%',
                                boxShadow: 'none',
                                position: 'relative',
                                mt: '-1px',
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            {/* Tab Panels */}
                            {isManager && value === 0 && (
                                <LeaveRequest requestExecutive={requestExecutive} selectedRequestExecutive={selectedRequestExecutive} handleRequestExecutive={handleRequestExecutive} requestProject={requestProject} selectedRequestProject={selectedRequestProject} handleRequestProject={handleRequestProject} requestStatus={requestStatus} selectedRequestStatus={selectedRequestStatus} handleRequestStatus={handleRequestStatus} handleLeaveRequestFilter={handleLeaveRequestFilter} handleLeaveRequestReset={handleLeaveRequestReset} leaveRequestColumn={leaveRequestColumn} leaveRequestData={leaveRequestData}
                                    selectedRequestRow={selectedRequestRow} isView={isView} setIsView={setIsView} handleReject={handleReject} handleApprove={handleApprove} handleCancelLeave={handleCancelLeave} pastLeaveData={pastLeaveData} upcomingLeaveData={upcomingLeaveData} pastLeaveColumns={pastLeaveColumns} upcomingLeaveColumns={upcomingLeaveColumns} teamImpactColumns={teamImpactColumns} teamImpactLeaveData={teamImpactLeaveData} projectImpactLeaveData={projectImpactLeaveData} pageSize5={pageSize5} setPageSize5={setPageSize5} requestDepartment={requestDepartment} selectedRequestDepartment={selectedRequestDepartment} handleRequestDepartment={handleRequestDepartment} approveModal={approveModal} handleApproveCloseModal={handleApproveCloseModal} handleRejectCloseModal={handleRejectCloseModal} rejectModal={rejectModal} departmentDropdownVisible={departmentDropdownVisible} handleLeaveAction={handleLeaveAction}
                                    processedCards={processedCards} isOwnLeaveRequest={isOwnLeaveRequest}
                                />
                            )}

                            {value === (isManager ? 1 : 0) && (
                                <ApplyForLeave isManager={isManager} date={date} handleDate={handleDate} remark={remark} handleRemark={handleRemark} handleApplyForLeave={handleApplyForLeave} pastLeaveColumns={pastLeaveColumns} upcomingLeaveColumns={upcomingLeaveColumns} pageSize={pageSize} setPageSize={setPageSize} pageSize1={pageSize1} setPageSize1={setPageSize1} handleLeaveTypeRadio={handleLeaveTypeRadio} leaveTypeRadio={leaveTypeRadio} handleDeleteDate={handleDeleteDate} teamImpactColumns={teamImpactColumns} selectedImpactDate={selectedImpactDate} leaveTypeDdl={leaveTypeDdl} setLeaveTypeDdl={setLeaveTypeDdl} leaveTypeOptions={leaveTypeOptions} handleExecutiveDdl={handleExecutiveDdl} executiveDdl={executiveDdl} selectedExecutiveDdl={selectedExecutiveDdl} leavePaid={leavePaid}
                                    setLeavePaid={setLeavePaid} leavePaidOptions={leavePaidOptions} handleLongLeaveFromDate={handleLongLeaveFromDate} handleLongLeaveToDate={handleLongLeaveToDate} fromDateLeave={fromDateLeave} toDateLeave={toDateLeave} pastLeaveData={pastLeaveData} upcomingLeaveData={upcomingLeaveData} selectedDate={selectedDate} setSelectedDate={setSelectedDate}
                                    teamImpactLeaveData={teamImpactLeaveData} projectImpactLeaveData={projectImpactLeaveData} leaveOptions={leaveOptions}
                                    openSuccess={openSuccess} setOpenSuccess={setOpenSuccess} handleSuccessClose={handleSuccessClose} leaveHistory={leaveHistory} getLeaveHistory={getLeaveHistory} isLongLeaveApprover={isLongLeaveApprover}
                                    getHolidayList={getHolidayList} holidayList={holidayList}
                                />
                            )}

                            {value === (isManager ? 2 : 1) && (
                                <LeaveHistory fromDate={fromDate} handleFromDate={handleFromDate} toDate={toDate} handleToDate={handleToDate} leaveType={leaveType} handleLeaveType={handleLeaveType} leaveHistoryData={leaveHistoryData} handleFilterLeaveHistory={handleFilterLeaveHistory} handleLeaveHistoryReset={handleLeaveHistoryReset} anchorEl={anchorEl} handleMenuOpen={handleMenuOpen} handleMenuClose={handleMenuClose} openMenu={openMenu} viewLeaveHistoryModal={viewLeaveHistoryModal} handleViewLeaveHistoryCloseModal={handleViewLeaveHistoryCloseModal} handleViewLeaveHistoryOpenModal={handleViewLeaveHistoryOpenModal} historyColumns={historyColumns} historyRows={historyRows} viewLeaveHistoryData={viewLeaveHistoryData} cancelModal={cancelModal} handleCancelConfirm={handleCancelConfirm} handleCancel={handleCancel} handleCancelClick={handleCancelClick} editModalOpen={editModalOpen} setEditModalOpen={setEditModalOpen} setEditModalData={setEditModalData} editModalData={editModalData} pastLeaveColumns={pastLeaveColumns} upcomingLeaveColumns={upcomingLeaveColumns} handleLeaveTypeRadio={handleLeaveTypeRadio} leaveTypeRadio={leaveTypeRadio} handleDeleteDate={handleDeleteDate} teamImpactColumns={teamImpactColumns} selectedImpactDate={selectedImpactDate} date={date} handleDate={handleDate} remark={remark} handleRemark={handleRemark} handleApplyForLeave={handleApplyForLeave} pageSize2={pageSize2} setPageSize2={setPageSize2}
                                    pastLeaveData={pastLeaveData} upcomingLeaveData={upcomingLeaveData} getHolidayList={getHolidayList}
                                    handleEditDate={handleEditDate} handleEditRemark={handleEditRemark} handleUpdateLeave={handleUpdateLeave} handleEditOpenModal={handleEditOpenModal} handleEditCloseModal={handleEditCloseModal} leaveTypeOptions={leaveTypeOptions}
                                    openSuccess={openSuccess} setOpenSuccess={setOpenSuccess} handleSuccessClose={handleSuccessClose} teamImpactLeaveData={teamImpactLeaveData} projectImpactLeaveData={projectImpactLeaveData} isEditMode={isEditMode} executiveHistory={executiveHistory} selectedExecutiveHistory={selectedExecutiveHistory} handleExecutiveHistory={handleExecutiveHistory} isManager={isManager}
                                />
                            )}

                            {value === (isManager ? 3 : 2) && (
                                <MyTeam myTeamFromDate={myTeamFromDate} handleMyTeamFromDate={handleMyTeamFromDate} myTeamToDate={myTeamToDate} handleMyTeamToDate={handleMyTeamToDate} executive={executive} handleExecutive={handleExecutive} selectedExecutive={selectedExecutive} department={department} selectedDepartment={selectedDepartment} handleDepartment={handleDepartment} myTeamleaveType={myTeamleaveType} myTeamSelectedLeaveType={myTeamSelectedLeaveType} handleMyTeamLeaveType={handleMyTeamLeaveType} handleMyTeamFilter={handleMyTeamFilter} handleMyTeamReset={handleMyTeamReset} myTeamData={myTeamData} myTeamColumn={myTeamColumn} leaveRequestColumn={leaveRequestColumn} leaveTypeOptions={leaveTypeOptions} setPageSize3={setPageSize3} pageSize3={pageSize3} team={team} selectedTeam={selectedTeam} handleTeam={handleTeam}
                                />
                            )}

                            {value === (isManager ? 4 : 3) && (
                                <AttendanceReport monthYear={monthYear} handleMonthYear={handleMonthYear} executive={executive} handleExecutive={handleExecutive} selectedExecutive={selectedExecutive} handleAttendanceReportFilter={handleAttendanceReportFilter} handleAttendanceReportReset={handleAttendanceReportReset} attendanceReportData={attendanceReportData} attendanceReportColumn={attendanceReportColumn} formattedAttendanceData={formattedAttendanceData} pageSize4={pageSize4} setPageSize4={setPageSize4}
                                />
                            )}
                            {value === (isManager ? 5 : 4) && (

                                <LeaveBalanceReport monthYear={monthYear} handleMonthYear={handleMonthYear} leaveReportExecutive={leaveReportExecutive} handleLeaveReportExecutive={handleLeaveReportExecutive} selectedLeaveReportExecutive={selectedLeaveReportExecutive} handleLeaveBalanceReportFilter={handleLeaveBalanceReportFilter} handleLeaveBalanceReportReset={handleLeaveBalanceReportReset} leaveBalanceReportData={leaveBalanceReportData} leaveBalanceReportColumn={leaveBalanceReportColumn} formattedAttendanceData={formattedAttendanceData} pageSize4={pageSize4} setPageSize4={setPageSize4} noOfMonths={noOfMonths} handleNoOfMonths={handleNoOfMonths} />
                            )}
                        </Box>

                    </Grid>

                    {open && (
                        <IconButton
                            onClick={handleFilterClick}
                            sx={{
                                position: "absolute",
                                top: "120px",   // fixed top
                                right: "20px", // fixed left
                                width: 20,
                                height: 20,
                                opacity: 1,
                                p: 0,
                                zIndex: 10,
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '25px',
                                    height: '37px',
                                    backgroundColor: '#4682B4', // match your theme
                                    borderTopLeftRadius: '10px',
                                    borderBottomLeftRadius: '10px',
                                    borderTopRightRadius: 0,
                                    borderBottomRightRadius: 0,
                                    border: 'none',
                                }}
                            >
                                <Icon icon="material-symbols:keyboard-double-arrow-left-rounded" width={24} height={24} color="#FFFFFF" />
                            </Box>
                        </IconButton>

                    )}

                    {isLeaveHistory && !open && (
                        <Grid item xs={12} md={3}>
                            <Card
                                sx={{
                                    px: 1.5,
                                    py: 1,
                                    border: "1px solid #E5E7EB",
                                    borderRadius: "12px",
                                    boxShadow: "none",
                                }}
                            >
                                <Stack spacing={1}>
                                    {/* Title */}
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                                        <Typography sx={{ color: '#0A0A0A', fontSize: '16px', fontWeight: 500 }}>Leave Balance</Typography>
                                        <KeyboardDoubleArrowRightOutlinedIcon fontSize="small" sx={{ color: '#70747A', cursor: 'pointer' }} onClick={handleFilterCollapseClick} />
                                    </Box>
                                    {/* Leave Cards */}
                                    <Card
                                        sx={{
                                            px: 1.5,
                                            py: 1,
                                            border: "1px solid #E5E7EB",
                                            borderRadius: "12px",
                                            boxShadow: "none",
                                        }}
                                    >
                                        <Stack spacing={1}>
                                            {leaveData?.length > 0 ? (
                                                leaveData.map((item, index) => (
                                                    <Card
                                                        key={index}
                                                        variant="outlined"
                                                        sx={{
                                                            p: 2,
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            alignItems: "center",
                                                            borderRadius: "12px",
                                                            border: "1px solid #E5E5E5",
                                                            boxShadow: "none",
                                                        }}
                                                    >
                                                        <Stack
                                                            direction="row"
                                                            spacing={1}
                                                            alignItems="center"
                                                        >
                                                            <Icon
                                                                icon={item.icon}
                                                                color={item.color}
                                                                width="22"
                                                            />

                                                            <Typography fontSize={14}>
                                                                {item.label}
                                                            </Typography>
                                                        </Stack>

                                                        <Chip
                                                            label={item.count}
                                                            size="small"
                                                            sx={{
                                                                borderRadius: "8px",
                                                                bgcolor: "#FFFFFF",
                                                                boxShadow: "0px 0px 2px 0px #0000002E",
                                                            }}
                                                        />
                                                    </Card>
                                                ))
                                            ) : (
                                                <Typography
                                                    fontSize={14}
                                                    fontWeight={500}
                                                    color="#717883"
                                                    textAlign="center"
                                                >
                                                    No leave data available
                                                </Typography>
                                            )}
                                        </Stack>
                                    </Card>

                                    <Card
                                        variant="outlined"
                                        sx={{
                                            p: 2,
                                            borderRadius: "12px",
                                            border: "1px solid #E5E7EB",
                                            boxShadow: "none",
                                            height: 200,
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-between",
                                        }}
                                    >

                                        {pieData?.length > 0 ? (
                                            <Stack direction="row" spacing={2} sx={{ height: "100%" }}>

                                                {/* 🔹 LEGEND */}
                                                <Stack
                                                    spacing={2}
                                                    sx={{
                                                        flex: 1,
                                                        overflowY: "auto",
                                                        pr: 1,
                                                    }}
                                                >
                                                    {pieData.map((item, index) => (
                                                        <Stack
                                                            key={index}
                                                            direction="row"
                                                            spacing={1.5}
                                                            alignItems="center"
                                                        >
                                                            <Box
                                                                sx={{
                                                                    width: 6,
                                                                    height: 28,
                                                                    borderRadius: "6px",
                                                                    bgcolor: item.color,
                                                                }}
                                                            />

                                                            <Box>
                                                                <Typography
                                                                    fontSize={12}
                                                                    color="#6B7280"
                                                                >
                                                                    {item.label}
                                                                </Typography>

                                                                <Typography
                                                                    fontSize={15}
                                                                    fontWeight={600}
                                                                >
                                                                    {item.value} days
                                                                </Typography>
                                                            </Box>
                                                        </Stack>
                                                    ))}
                                                </Stack>

                                                {/* 🔹 PIE */}
                                                <Box
                                                    sx={{
                                                        width: 150,
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <Box sx={{ width: 140, height: 140 }}>
                                                        <ResponsiveContainer
                                                            width="100%"
                                                            height="100%"
                                                        >
                                                            <PieChart>
                                                                <Pie
                                                                    data={pieData}
                                                                    cx="50%"
                                                                    cy="50%"
                                                                    innerRadius={50}
                                                                    outerRadius={70}
                                                                    paddingAngle={3}
                                                                    dataKey="value"
                                                                    stroke="none"
                                                                >
                                                                    {pieData.map((entry, index) => (
                                                                        <Cell
                                                                            key={index}
                                                                            fill={entry.color}
                                                                        />
                                                                    ))}
                                                                </Pie>
                                                            </PieChart>
                                                        </ResponsiveContainer>
                                                    </Box>
                                                </Box>
                                            </Stack>
                                        ) : (
                                            <Box
                                                sx={{
                                                    height: "100%",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <Typography
                                                    fontSize={14}
                                                    fontWeight={500}
                                                    color="#717883"
                                                >
                                                    No leave data available
                                                </Typography>
                                            </Box>
                                        )}
                                    </Card>

                                </Stack>
                            </Card>
                        </Grid>
                    )}

                    {isMyTeam && !open && (
                        <Grid item xs={12} md={3} sx={{ height: "80vh", overflow: "hidden" }}>
                            <Card
                                sx={rightCardStyle}
                            >
                                <Stack spacing={2} sx={{ height: "100%", minHeight: 0 }}>

                                    {/*  Birthdays */}
                                    <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", overflow: "hidden" }}>

                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                                            <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>Birthday Calendar</Typography>
                                            <KeyboardDoubleArrowRightOutlinedIcon fontSize="small" sx={{ color: '#70747A', cursor: 'pointer' }} onClick={handleFilterCollapseClick} />
                                        </Box>
                                        <Card sx={{ ...cardStyle, flex: 1, minHeight: 0, overflowY: "auto" }}>
                                            <Stack spacing={2}>
                                                {birthdayData?.length > 0 ? (
                                                    birthdayData.map((item, i) => (
                                                        <Stack key={i} direction="row" spacing={1.5}>
                                                            <Icon icon="fxemoji:partypopper" width="24" />

                                                            <Box>
                                                                <Typography
                                                                    fontSize={14}
                                                                    fontWeight={500}
                                                                    color="#717883"
                                                                >
                                                                    {item.ExecutiveName}
                                                                </Typography>

                                                                <Typography
                                                                    fontSize={12}
                                                                    fontWeight={500}
                                                                    color="#717883"
                                                                >
                                                                    {item.Department}
                                                                </Typography>
                                                            </Box>

                                                            <Chip
                                                                label={Moment(item.DateOfBirth).format("DD-MMM")}
                                                                size="small"
                                                                sx={{
                                                                    bgcolor: "#FFFFFF",
                                                                    color: '#717883',
                                                                    border: "1px solid #E5E7EB"
                                                                }}
                                                            />
                                                        </Stack>
                                                    ))
                                                ) : (
                                                    <Typography
                                                        fontSize={14}
                                                        fontWeight={500}
                                                        color="#717883"
                                                        textAlign="center"
                                                    >
                                                        No birthdays today
                                                    </Typography>
                                                )}
                                            </Stack>
                                        </Card>
                                    </Box>

                                    {/* 🏆 Milestones */}
                                    <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", overflow: "hidden" }}>
                                        <Typography sx={{ fontSize: '14px', fontWeight: 500, mb: 1 }}>
                                            Team Milestones
                                        </Typography>

                                        <Card sx={{ ...cardStyle, flex: 1, minHeight: 0, overflowY: "auto" }}>
                                            <Stack spacing={2}>
                                                {milestonesData?.length > 0 ? (
                                                    milestonesData.map((item, i) => {
                                                        const match = item.EmployeeName.match(/\((.*?)\)/);
                                                        const employeeCode = match ? match[1] : "";

                                                        const employeeName = item.EmployeeName
                                                            .replace(/\(.*?\)/, "")
                                                            .trim();

                                                        return (
                                                            <Box key={i}>
                                                                <Stack direction="row" justifyContent="space-between">
                                                                    <Box>
                                                                        <Typography
                                                                            fontSize={14}
                                                                            fontWeight={500}
                                                                            color="#717883"
                                                                        >
                                                                            {employeeName}
                                                                        </Typography>

                                                                        <Typography
                                                                            fontSize={12}
                                                                            color="#717883"
                                                                        >
                                                                            ({employeeCode})
                                                                        </Typography>
                                                                    </Box>

                                                                    <Box textAlign="right">
                                                                        <Typography
                                                                            fontSize={14}
                                                                            fontWeight={500}
                                                                            color="#717883"
                                                                        >
                                                                            : {item.JoiningDate}
                                                                        </Typography>

                                                                        <Typography
                                                                            fontSize={12}
                                                                            color="#717883"
                                                                        >
                                                                            ({item.Milestone})
                                                                        </Typography>
                                                                    </Box>
                                                                </Stack>
                                                            </Box>
                                                        );
                                                    })
                                                ) : (
                                                    <Typography
                                                        fontSize={14}
                                                        fontWeight={500}
                                                        color="#717883"
                                                        textAlign="center"
                                                    >
                                                        No milestones available
                                                    </Typography>
                                                )}
                                            </Stack>
                                        </Card>
                                    </Box>

                                    {/* 🎊 Holidays */}
                                    <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", overflow: "hidden" }}>
                                        <Typography sx={{ fontSize: '14px', fontWeight: 500, mb: 1 }}>
                                            Holiday Reminder
                                        </Typography>

                                        <Card sx={{ ...cardStyle, flex: 1, minHeight: 0, overflowY: "auto" }}>
                                            <Stack spacing={1.5}>
                                                {holidayData?.length > 0 ? (
                                                    holidayData.map((item, i) => (
                                                        <Stack
                                                            key={i}
                                                            direction="row"
                                                            justifyContent="space-between"
                                                        >
                                                            <Typography
                                                                fontSize={14}
                                                                fontWeight={500}
                                                                color="#717883"
                                                            >
                                                                {item.Remarks || "Holiday"}
                                                            </Typography>

                                                            <Typography
                                                                fontSize={14}
                                                                fontWeight={500}
                                                                color="#717883"
                                                            >
                                                                : {item.Date}
                                                            </Typography>
                                                        </Stack>
                                                    ))
                                                ) : (
                                                    <Typography
                                                        fontSize={14}
                                                        fontWeight={500}
                                                        color="#717883"
                                                        textAlign="center"
                                                    >
                                                        No holidays available
                                                    </Typography>
                                                )}
                                            </Stack>
                                        </Card>
                                    </Box>

                                </Stack>
                            </Card>
                        </Grid>
                    )}

                    {isLeaveRequest && !open && (
                        <Grid item xs={12} md={3}>
                            <Card
                                sx={rightCardStyle}
                            >
                                <Stack spacing={1}>
                                    {/* Title */}
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                                        <Typography sx={{ color: '#0A0A0A', fontSize: '16px', fontWeight: 500 }}>Pending Approvals</Typography>
                                        <KeyboardDoubleArrowRightOutlinedIcon fontSize="small" sx={{ color: '#70747A', cursor: 'pointer' }} onClick={handleFilterCollapseClick} />
                                    </Box>
                                    {/* Leave Cards */}
                                    <Card
                                        sx={{
                                            px: 1.5,
                                            py: 1,
                                            border: "1px solid #E5E7EB",
                                            borderRadius: "12px",
                                            boxShadow: "none",
                                        }}
                                    >
                                        <Stack spacing={1}>
                                            {leaveRequestApprovalData?.map((item, index) => (
                                                <Stack
                                                    key={index}
                                                    direction="row"
                                                    alignItems="center"
                                                    justifyContent="space-between"
                                                >
                                                    <Stack direction="row" spacing={1} alignItems="center">
                                                        <Box
                                                            sx={{
                                                                width: 10,
                                                                height: 10,
                                                                borderRadius: "50%",
                                                                backgroundColor: item.color,
                                                                flexShrink: 0,
                                                            }}
                                                        />
                                                        <Typography fontSize={14} fontWeight={500}>{item.label}</Typography>
                                                    </Stack>

                                                    <Chip
                                                        label={item.count}
                                                        size="small"
                                                        sx={{
                                                            borderRadius: "8px",
                                                            bgcolor: "#FFFFFF",
                                                            boxShadow: "0px 0px 2px 0px #0000002E",
                                                        }}
                                                    />
                                                </Stack>
                                            ))}
                                        </Stack>
                                    </Card>

                                    <Card
                                        sx={{
                                            px: 1,
                                            py: 1,
                                            border: "1px solid #E5E7EB",
                                            borderRadius: "12px",
                                            boxShadow: "none",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                mb: 1,
                                            }}
                                        >
                                            <Typography
                                                variant="h6"
                                                sx={{
                                                    fontWeight: 500,
                                                    color: "#111827",
                                                }}
                                            >
                                                Team Availability
                                            </Typography>

                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DesktopDatePicker
                                                    inputFormat="dd/MMM/yyyy"
                                                    value={teamFromDate ? Moment(teamFromDate, "DD-MMM-YYYY").toDate() : null}
                                                    onChange={handleTeamFromDate}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            size="small"
                                                            {...params}
                                                            sx={{ width: 120 }}
                                                            error={false}

                                                        />
                                                    )}
                                                />
                                            </LocalizationProvider>
                                        </Box>

                                        <Box sx={{ height: 118, width: "100%" }}>
                                            <ResponsiveContainer width="100%" height="100%">
                                                <BarChart
                                                    data={teamAvailabilityData}
                                                    margin={{
                                                        top: 20,
                                                        right: 30,
                                                        left: 30,
                                                        bottom: 5
                                                    }}
                                                >
                                                    <CartesianGrid
                                                        vertical={false}
                                                        horizontal={false}
                                                    />

                                                    <XAxis
                                                        dataKey="month"
                                                        axisLine={{
                                                            stroke: "#838383",
                                                            strokeWidth: 2
                                                        }}
                                                        tickLine={false}
                                                        tick={{
                                                            fill: "#6B7280",
                                                            fontSize: 14,
                                                            fontWeight: 500
                                                        }}
                                                        dy={10}
                                                    />

                                                    <YAxis
                                                        hide
                                                        domain={[0, "dataMax + 10"]}
                                                    />

                                                    <Bar
                                                        dataKey="count"
                                                        fill="#5470E3"
                                                        barSize={50}
                                                        radius={[4, 4, 0, 0]}
                                                        isAnimationActive={false}

                                                    >
                                                        <LabelList
                                                            dataKey="count"
                                                            position="top"
                                                            formatter={(val) =>
                                                                val < 10 ? `0${val}` : val
                                                            }
                                                            style={{
                                                                fill: "#838383",
                                                                fontSize: 15,
                                                                fontWeight: 500
                                                            }}
                                                            offset={12}
                                                        />
                                                    </Bar>
                                                </BarChart>
                                            </ResponsiveContainer>
                                        </Box>
                                    </Card>
                                    <Card
                                        sx={{
                                            px: 1,
                                            py: 1,
                                            border: "1px solid #E5E7EB",
                                            borderRadius: "12px",
                                            boxShadow: "none",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                mb: 1,
                                            }}
                                        >
                                            <Typography
                                                variant="h6"
                                                sx={{
                                                    fontWeight: 500,
                                                    color: "#111827",
                                                }}
                                            >
                                                Project Team Availability
                                            </Typography>

                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DesktopDatePicker
                                                    inputFormat="dd/MMM/yyyy"
                                                    value={projectTeamFromDate ? Moment(projectTeamFromDate, "DD-MMM-YYYY").toDate() : null}
                                                    onChange={handleProjectTeamFromDate}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            size="small"
                                                            {...params}
                                                            sx={{ width: 100 }}
                                                            error={false}
                                                            inputProps={{
                                                                ...params.inputProps,
                                                                placeholder: projectTeamFromDate
                                                                    ? params.inputProps?.placeholder
                                                                    : "From Date",
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </LocalizationProvider>
                                        </Box>

                                        <Box sx={{ height: 118, width: "100%" }}>
                                            <ResponsiveContainer width="100%" height="100%">
                                                <BarChart
                                                    data={projectTeamAvailabilityData}
                                                    margin={{
                                                        top: 20,
                                                        right: 30,
                                                        left: 30,
                                                        bottom: 5
                                                    }}
                                                >
                                                    <CartesianGrid
                                                        vertical={false}
                                                        horizontal={false}
                                                    />

                                                    <XAxis
                                                        dataKey="month"
                                                        axisLine={{
                                                            stroke: "#838383",
                                                            strokeWidth: 2
                                                        }}
                                                        tickLine={false}
                                                        tick={{
                                                            fill: "#6B7280",
                                                            fontSize: 14,
                                                            fontWeight: 500
                                                        }}
                                                        dy={10}
                                                    />

                                                    <YAxis
                                                        hide
                                                        domain={[0, "dataMax + 10"]}
                                                    />

                                                    <Bar
                                                        dataKey="count"
                                                        fill="#5470E3"
                                                        barSize={50}
                                                        radius={[4, 4, 0, 0]}
                                                        isAnimationActive={false}

                                                    >
                                                        <LabelList
                                                            dataKey="count"
                                                            position="top"
                                                            formatter={(val) =>
                                                                val < 10 ? `0${val}` : val
                                                            }
                                                            style={{
                                                                fill: "#838383",
                                                                fontSize: 15,
                                                                fontWeight: 500
                                                            }}
                                                            offset={12}
                                                        />
                                                    </Bar>
                                                </BarChart>
                                            </ResponsiveContainer>
                                        </Box>
                                    </Card>
                                </Stack>
                            </Card>
                        </Grid>
                    )}


                </Grid>
                {isLoading && <LoadingProgressBar sx={{ py: 6 }} />}
            </Page >
        </>

    );
}